// ========================================================================================
// ENHANCED FILE DETECTION SYSTEM - GLOBAL SCOPE
// All file detection logic available globally for use throughout the script
// ========================================================================================

// File Input ID Mapping - Clear and Consistent Pattern
const FILE_INPUT_IDS = {
  // Main Jersey Product (existing IDs - maintain compatibility)
  JERSEY_CREST_HEAT: 'crest_logo',
  JERSEY_CREST_EMBROIDERY: 'crest_logo_2', 
  JERSEY_CHEST: 'chest_logo',
  
  // Individual Product Types - Standardized Pattern: {product}_{logo_type}_file
  CAP_CREST: 'cap_crest_file',
  BAG_CREST: 'bag_crest_file',
  HOODIE_CREST: 'hoodie_crest_file',
  HOODIE_CHEST: 'hoodie_chest_file',
  TOP_CREST: 'top_crest_file',
  TOP_CHEST: 'top_chest_file',
  JACKET_CREST: 'jacket_crest_file',
  PANT_CREST: 'pant_crest_file',
  SHORT_CREST: 'short_crest_file',
  PS_LOGO: 'ps_logo_file'
};

// ========================================================================================
// GLOBAL FILE STORAGE - Store uploaded files as soon as they're selected
// This ensures we don't lose files even if DOM elements are missing later
// ========================================================================================

// Global storage for uploaded files
window.uploadedLogoFiles = {
  crestLogoFile: null,
  chestLogoFile: null,
  psLogoFile: null,
  sleeveLogoFile: null,
  sponsorLogoFile: null
};

/**
 * Store uploaded file globally when it's selected
 * Called immediately when user selects a file in any dropzone
 */
function storeUploadedFile(fileType, file) {
  window.uploadedLogoFiles[fileType] = file;
  console.log(`🎯 [FILE STORED] ${fileType}:`, file?.name || 'null');
  console.log('📁 [ALL STORED FILES]:', {
    crest: window.uploadedLogoFiles.crestLogoFile?.name || 'null',
    chest: window.uploadedLogoFiles.chestLogoFile?.name || 'null',
    ps: window.uploadedLogoFiles.psLogoFile?.name || 'null',
    sleeve: window.uploadedLogoFiles.sleeveLogoFile?.name || 'null',
    sponsor: window.uploadedLogoFiles.sponsorLogoFile?.name || 'null'
  });
}

/**
 * Get uploaded logo files - tries stored files first, then DOM detection as fallback
 */
function getUploadedLogoFiles() {
  let crestLogoFile = null;
  let chestLogoFile = null;
  let psLogoFile = null;
  
  // FIRST: Try to get files from global storage (most reliable)
  if (window.uploadedLogoFiles.crestLogoFile) {
    crestLogoFile = window.uploadedLogoFiles.crestLogoFile;
    console.log(`🎯 [STORED] Found crest logo: ${crestLogoFile.name}`);
  }
  
  if (window.uploadedLogoFiles.chestLogoFile) {
    chestLogoFile = window.uploadedLogoFiles.chestLogoFile;
    console.log(`🎯 [STORED] Found chest logo: ${chestLogoFile.name}`);
  }
  
  if (window.uploadedLogoFiles.psLogoFile) {
    psLogoFile = window.uploadedLogoFiles.psLogoFile;
    console.log(`🎯 [STORED] Found PS logo: ${psLogoFile.name}`);
  }
  
  // FALLBACK: If no stored files, try DOM detection
  if (!crestLogoFile || !chestLogoFile) {
    console.log('🔄 [FALLBACK] No stored files, trying DOM detection...');
    
    // Priority order for crest logos (Jersey first, then individual products)
    const crestPriorityIds = [
      'crest_logo',           // Main jersey heat press
      'crest_logo_2',         // Main jersey embroidery
      'hoodie_crest_file',    // Hoodie crest
      'top_crest_file',       // Top crest
      'jacket_crest_file',    // Jacket crest
      'cap_crest_file',       // Cap crest
      'bag_crest_file',       // Bag crest
      'pant_crest_file',      // Pant crest
      'short_crest_file'      // Short crest
    ];
    
    // Priority order for chest logos
    const chestPriorityIds = [
      'chest_logo',           // Main jersey chest
      'hoodie_chest_file',    // Hoodie chest
      'top_chest_file',       // Top chest
    ];
    
    // Find first available crest logo file (if not already found in storage)
    if (!crestLogoFile) {
      for (const id of crestPriorityIds) {
        const element = document.getElementById(id);
        if (element && element.files && element.files.length > 0) {
          crestLogoFile = element.files[0];
          console.log(`🎯 [DOM] Found crest logo: ${id} -> ${crestLogoFile.name}`);
          // Store for future use
          window.uploadedLogoFiles.crestLogoFile = crestLogoFile;
          break;
        }
      }
    }
    
    // Find first available chest logo file (if not already found in storage)
    if (!chestLogoFile) {
      for (const id of chestPriorityIds) {
        const element = document.getElementById(id);
        if (element && element.files && element.files.length > 0) {
          chestLogoFile = element.files[0];
          console.log(`🎯 [DOM] Found chest logo: ${id} -> ${chestLogoFile.name}`);
          // Store for future use
          window.uploadedLogoFiles.chestLogoFile = chestLogoFile;
          break;
        }
      }
    }
  }
  
  // Debug output
  console.log('📁 LOGO FILES FOUND:', {
    crestLogoFile: crestLogoFile?.name || 'null',
    chestLogoFile: chestLogoFile?.name || 'null', 
    psLogoFile: psLogoFile?.name || 'null'
  });
  
  return { 
    crestLogoFile, 
    chestLogoFile, 
    psLogoFile
  };
}

// ========================================================================================
// MAIN DOCUMENT READY FUNCTION
// ========================================================================================

function syncJerseyNameNumberSections() {
  var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
  var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
  var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
  var shouldShow = selectedFrontNumberValue === 'yes'
    || selectedNameValue === 'yes'
    || selectedBackNumberValue === 'yes';
  var $groups = $('.player_number_name.group');

  $groups.toggle(shouldShow).toggleClass('active', shouldShow);
  $groups.find('.adult_customizations, .youth_customizations')
    .stop(true, true)
    .toggle(shouldShow);
  $groups.find('.group-head .chevron')
    .css('transform', shouldShow ? 'rotate(180deg)' : 'rotate(0deg)');

  console.log('[JERSEY ROSTER] Section visibility:', {
    frontNumber: selectedFrontNumberValue,
    lastName: selectedNameValue,
    backNumber: selectedBackNumberValue,
    visible: shouldShow
  });
}

function refreshGenericNameNumberRoster() {
  var $rosterGroups = $('.player_number_name.group').filter(function () {
    return $(this).find('.adult_customizations, .youth_customizations').length > 0;
  });

  if (!$rosterGroups.length) return;

  var showName = $('input[name="properties[lastName]"]:checked').val() === 'yes';
  var showNumber = $('input[name="properties[frontNumber]"]:checked').val() === 'yes'
    || $('input[name="properties[backNumberSize]"]:checked').val() === 'yes';
  var showRoster = showName || showNumber;
  var formId = window.ProSoccerConfig?.product?.formId;
  var nameUnitPrice = getSelectedUnitPrice('input[name="properties[lastName]"]:checked', 7);
  var numberPriceSelector = $('input[name="properties[backNumberSize]"]:checked').val() === 'yes'
    ? 'input[name="properties[backNumberSize]"]:checked'
    : 'input[name="properties[frontNumber]"]:checked';
  var numberUnitPrice = getSelectedUnitPrice(numberPriceSelector, 5);

  $rosterGroups.toggle(showRoster).toggleClass('active', showRoster);
  $rosterGroups.find('.adult_customizations, .youth_customizations').toggle(showRoster);
  $rosterGroups.find('.group-head .chevron')
    .css('transform', showRoster ? 'rotate(180deg)' : 'rotate(0deg)');

  $rosterGroups.each(function () {
    var $group = $(this);

    $group.find('.adult_customizations, .youth_customizations').each(function () {
      var $sizeList = $(this);
      var isYouth = $sizeList.hasClass('youth_customizations');
      var sizeType = isYouth ? 'youth' : 'adult';
      var $quantityInputs = $('.' + sizeType + ' .tags-holder .quantity__input');

      if (!$quantityInputs.length) {
        $quantityInputs = $('.' + sizeType + ' .quantity__input');
      }

      $sizeList.children('div').each(function () {
        var $sizeRow = $(this);
        var sizeTag = $sizeRow.children('div').first().text().trim();
        var $quantityInput = $quantityInputs.filter(function () {
          return String($(this).attr('size_tag')).toLowerCase() === sizeTag.toLowerCase();
        }).first();
        var quantity = Math.floor(Number($quantityInput.val()) || 0);
        var $target = $sizeRow.children('div').eq(1);

        $target.empty();
        $sizeRow.toggle(quantity > 0);

        for (var playerIndex = 0; playerIndex < quantity && showRoster; playerIndex++) {
          var sizePrefix = isYouth ? 'Youth_' : 'Adult_';
          var fields = '<div class="roster-row"><div class="roster-mini-label">Player '
            + (playerIndex + 1)
            + '</div><div class="roster-grid'
            + (showName && showNumber ? ' cols-2' : '')
            + '">';

          if (showName) {
            fields += '<div class="roster-field"><input'
              + (formId ? ' form="' + formId + '"' : '')
              + ' name="properties[name-' + sizePrefix + sizeTag + '-' + playerIndex + ']"'
              + ' class="input__field player_name" placeholder="MESSI" type="text"'
              + ' style="text-transform:uppercase;"><span class="roster-price generic-roster-price" data-price-kind="name">$'
              + nameUnitPrice.toFixed(2) + '</span></div>';
          }

          if (showNumber) {
            fields += '<div class="roster-field"><input'
              + (formId ? ' form="' + formId + '"' : '')
              + ' name="properties[number-' + sizePrefix + sizeTag + '-' + playerIndex + ']"'
              + ' class="input__field player_number" min="0" placeholder="e.g. 10"'
              + ' onkeypress="handleOnlyTwoCharacters(event)" type="number"'
              + ' style="text-align:center;"><span class="roster-price generic-roster-price" data-price-kind="number">$'
              + numberUnitPrice.toFixed(2) + '</span></div>';
          }

          $target.append(fields + '</div></div>');
        }
      });
    });
  });

  console.log('[GENERIC ROSTER] Refreshed:', {
    lastName: showName,
    number: showNumber,
    nameUnitPrice: nameUnitPrice,
    numberUnitPrice: numberUnitPrice,
    visible: showRoster,
    nameInputs: $rosterGroups.find('.player_name').length,
    numberInputs: $rosterGroups.find('.player_number').length
  });
}

function getSelectedUnitPrice(inputSelector, fallback) {
  var $input = $(inputSelector);
  if (!$input.length) return fallback;

  var priceText = $input.closest('.toggle-left-right-holder').find('.field-price').first().text();
  var priceMatch = priceText.match(/\$([\d]+(?:\.[\d]+)?)/);
  return priceMatch ? Number(priceMatch[1]) : fallback;
}

$(document).ready(function () {

  // ========================================================================================
  // MAIN CUSTOMIZATION LOGIC
  // ========================================================================================

  // The image-based font selectors need explicit behavior because their controls are divs,
  // not native select elements.
  $('.font-img-select').each(function () {
    var $selector = $(this);
    var $trigger = $selector.find('.font-img-trigger');
    var $options = $selector.find('.font-img-option');
    var selectedValue = $selector.find('.font-img-value').val();
    var $selectedOption = selectedValue
      ? $options.filter('[data-value="' + selectedValue + '"]')
      : $options.filter('.selected').first();

    $trigger.attr({
      role: 'button',
      tabindex: '0',
      'aria-haspopup': 'listbox',
      'aria-expanded': 'false'
    });
    $selector.find('.font-img-dropdown').attr('role', 'listbox');
    $options.attr({ role: 'option', tabindex: '0' });

    if ($selectedOption.length) {
      $options.removeClass('selected').attr('aria-selected', 'false');
      $selectedOption.addClass('selected').attr('aria-selected', 'true');
      $trigger.find('.font-img-trigger-text').text($selectedOption.data('label'));
      
      // Initialize color filtering based on selected font type
      var fontType = $selectedOption.attr('data-type');
      var $row = $selector.closest('.row, .font-options-row');
      var $colorSelects;
      
      if ($row.length) {
        $colorSelects = $row.find('select[name*="Color"]');
      } else {
        var $parentContainer = $selector.closest('.toggle-left-right-holder, .group-body');
        var fontPropertyName = $selector.find('.font-img-value').attr('name');
        
        if (fontPropertyName && fontPropertyName.includes('Number')) {
          $colorSelects = $parentContainer.find('select[name*="Font Color"], select[name*="Number Font Color"]');
        } else if (fontPropertyName && fontPropertyName.includes('Name')) {
          $colorSelects = $parentContainer.find('select[name*="Player Font Color"], select[name*="Last Name Font Color"]');
        } else {
          $colorSelects = $parentContainer.find('select[name*="Color"]').first();
        }
      }
      
      if (fontType === 'adidas') {
        $colorSelects.find('option[data-color-number-family*="adidas"], option[data-color-name-family*="adidas"]').show();
        $colorSelects.find('option[data-color-number-family="global"], option[data-color-name-family="global"]').hide();
      } else if (fontType === 'global') {
        $colorSelects.find('option[data-color-number-family*="global"], option[data-color-name-family*="global"]').show();
        $colorSelects.find('option[data-color-number-family="adidas"]:not([data-color-number-family*="global"]), option[data-color-name-family="adidas"]:not([data-color-name-family*="global"])').hide();
      }
    }
  });

  var nameOptionTargets = {
    'properties[lastName]': '.back_name',
    'properties[TopLastName]': '.top_last_name_holder',
    'properties[HoodieLastName]': '.hoodie_last_name_holder',
    'properties[jacketLastName]': '.jacket_last_name_holder'
  };

  function syncNameOptionVisibility(input) {
    var target = nameOptionTargets[input.name];
    if (!target) return;

    var showOptions = input.checked && input.value === 'yes';
    $(target).stop(true, true).toggle(showOptions);
    console.log('[NAME OPTION] Visibility updated:', {
      input: input.name,
      value: input.value,
      visible: showOptions
    });
  }

  Object.keys(nameOptionTargets).forEach(function (inputName) {
    var $selectedInput = $('input[name="' + inputName + '"]:checked');
    if ($selectedInput.length) {
      syncNameOptionVisibility($selectedInput[0]);
    }
  });

  $(document).on(
    'change',
    'input[name="properties[lastName]"], input[name="properties[TopLastName]"], input[name="properties[HoodieLastName]"], input[name="properties[jacketLastName]"]',
    function () {
      syncNameOptionVisibility(this);
    }
  );

  $(document).on(
    'change',
    'input[name="properties[lastName]"], input[name="properties[frontNumber]"], input[name="properties[backNumberSize]"], .adult .quantity__input, .youth .quantity__input',
    refreshGenericNameNumberRoster
  );

  refreshGenericNameNumberRoster();

  function closeFontDropdowns($except) {
    $('.font-img-select.open').not($except).removeClass('open')
      .find('.font-img-trigger').attr('aria-expanded', 'false');
  }

  $(document).on('click', '.font-img-trigger', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $selector = $(this).closest('.font-img-select');
    var shouldOpen = !$selector.hasClass('open');
    closeFontDropdowns($selector);
    $selector.toggleClass('open', shouldOpen);
    $(this).attr('aria-expanded', shouldOpen ? 'true' : 'false');
  });

  $(document).on('click', '.font-img-option', function (event) {
    event.preventDefault();
    event.stopPropagation();

    var $option = $(this);
    var $selector = $option.closest('.font-img-select');
    var value = $option.attr('data-value');
    var label = $option.attr('data-label') || $option.text().trim();
    var optionType = $option.attr('data-type');

    $selector.find('.font-img-option').removeClass('selected').attr('aria-selected', 'false');
    $option.addClass('selected').attr('aria-selected', 'true');
    $selector.find('.font-img-trigger-text').text(label);
    $selector.find('.font-img-value').val(value).trigger('change');
    $selector.removeClass('open').find('.font-img-trigger').attr('aria-expanded', 'false');

    // Filter color options based on font type (Adidas vs Global)
    // Find color select in the same row/section only
    var $row = $selector.closest('.row, .font-options-row');
    var $colorSelects;
    
    if ($row.length) {
      // If in a row layout, find color select in same row
      $colorSelects = $row.find('select[name*="Color"]');
    } else {
      // Fallback: find sibling color select in parent container
      var $parentContainer = $selector.closest('.toggle-left-right-holder, .group-body');
      var fontPropertyName = $selector.find('.font-img-value').attr('name');
      
      // Determine which color select to target based on font type
      if (fontPropertyName && fontPropertyName.includes('Number')) {
        $colorSelects = $parentContainer.find('select[name*="Font Color"], select[name*="Number Font Color"]');
      } else if (fontPropertyName && fontPropertyName.includes('Name')) {
        $colorSelects = $parentContainer.find('select[name*="Player Font Color"], select[name*="Last Name Font Color"]');
      } else {
        $colorSelects = $parentContainer.find('select[name*="Color"]').first();
      }
    }
    
    if (optionType == 'adidas') {
      // Show only Adidas colors (includes shared colors)
      $colorSelects.find('option[data-color-number-family*="adidas"], option[data-color-name-family*="adidas"]').show();
      $colorSelects.find('option[data-color-number-family="global"], option[data-color-name-family="global"]').hide();
      
      // Select first visible Adidas color
      $colorSelects.each(function() {
        var $firstVisible = $(this).find('option[data-color-number-family*="adidas"], option[data-color-name-family*="adidas"]').first();
        if ($firstVisible.length) {
          $(this).val($firstVisible.val()).trigger('change');
        }
      });
    } else if (optionType == 'global') {
      // Show only global colors (includes shared colors)
      $colorSelects.find('option[data-color-number-family*="global"], option[data-color-name-family*="global"]').show();
      $colorSelects.find('option[data-color-number-family="adidas"]:not([data-color-number-family*="global"]), option[data-color-name-family="adidas"]:not([data-color-name-family*="global"])').hide();
      
      // Select first visible global color
      $colorSelects.each(function() {
        var $firstVisible = $(this).find('option[data-color-number-family*="global"], option[data-color-name-family*="global"]').first();
        if ($firstVisible.length) {
          $(this).val($firstVisible.val()).trigger('change');
        }
      });
    }
  });

  $(document).on('click', function (event) {
    if (!$(event.target).closest('.font-img-select').length) {
      closeFontDropdowns();
    }
  });

  $(document).on('keydown', '.font-img-trigger, .font-img-option', function (event) {
    if (event.key === 'Escape') {
      closeFontDropdowns();
      return;
    }

    if ((event.key === 'Enter' || event.key === ' ') && $(this).hasClass('font-img-trigger')) {
      event.preventDefault();
      $(this).trigger('click');
    } else if ((event.key === 'Enter' || event.key === ' ') && $(this).hasClass('font-img-option')) {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  // Handle accordion-style groups (like Names & Numbers section)
  $('.group .group-head').on('click', function () {
    var $group = $(this).closest('.group');
    var $content = $group.find('.adult_customizations, .youth_customizations');

    // Toggle active class
    $group.toggleClass('active');

    // Slide toggle the content
    if ($group.hasClass('active')) {
      $content.slideDown(300);
      $(this).find('.chevron').css('transform', 'rotate(180deg)');
    } else {
      $content.slideUp(300);
      $(this).find('.chevron').css('transform', 'rotate(0deg)');
    }
  });

  // Jersey controls share the .player_number_name class with other product types.
  // Only apply the Jersey visibility/roster initialization when Jersey controls exist.
  var jerseyNameNumberControls = $(
    'input[name="properties[frontNumber]"], ' +
    'input[name="properties[lastName]"], ' +
    'input[name="properties[backNumberSize]"]'
  );
  if (jerseyNameNumberControls.length) {
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
    syncJerseyNameNumberSections();

    $('.adult .quantity__input, .youth .quantity__input').each(function() {
      if ($(this).val() > 0) {
        $(this).trigger('change');
      }
    });
  }
  
  // Check initial state of show_custom_info checkbox
  setTimeout(function() {
    var $checkbox = $('#show_custom_info');
    console.log('Initial checkbox state - Checked:', $checkbox.prop('checked'), 'Disabled:', $checkbox.prop('disabled'));
    if ($checkbox.prop('checked') && !$checkbox.prop('disabled')) {
      console.log('Checkbox is checked on load, showing custom_info');
      $('.custom_info').slideDown(300);
    }
  }, 500);



  // Hide individual fields based on selection
  if (selectedFrontNumberValue == "no" && selectedBackNumberValue == "no") {
    $(".player_number_input").hide();
  }
  if (selectedNameValue == "no") {
    $(".player_name_input").hide();
  }
});

/* ========== Script Block 1 ========== */
$(document).ready(function () {

  $('.number-font-select-selected').on('click', function () {
    $('.number-font-select-options').toggle();
  });
  $('.number-font-select-option').click(function () {
    var optionType = $(this).data('type');
    if (optionType == 'adidas') {
      $("option[data-color-number-family*='adidas']").show();
      $("option[data-color-number-family='global']").hide();
      $("option[data-color-number-family*='adidas']").first().prop('selected', true);
    } else {

      $("option[data-color-number-family*='global']").show();
      $("option[data-color-number-family='adidas']").hide();
      $("option[data-color-number-family*='global']").first().prop('selected', true);
    }
    var value = $(this).data('value');
    var label = $(this).find('img').attr('alt');
    $('.number-font-select-selected').text(label);
    $('.number-font-select-options').hide();
  });
  if (window.ProSoccerConfig.flags.isAdidasCollection) {
    $("option[data-color-number-family*='adidas']").show();
    $("option[data-color-number-family='global']").hide();
  }
});

/* ========== Script Block 2 - NAME FONT SELECTORS ========== */
$(document).ready(function () {
  // Use event delegation to handle dynamically loaded name font selectors
  $(document).on('click', '.name-font-select-selected', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('👕 [NAME FONT] Dropdown clicked', this);
    
    // Close all other dropdowns first
    $('.name-font-select-options').hide();
    
    // Find the options for this specific dropdown
    const $clicked = $(this);
    const $options = $clicked.siblings('.name-font-select-options');
    
    console.log('👕 [NAME FONT] Options found:', $options.length);
    console.log('👕 [NAME FONT] Options HTML:', $options.html());
    
    if ($options.length > 0) {
      // Reset any previous positioning
      $options.css({
        position: 'absolute',
        top: '100%',
        left: '0',
        width: '100%',
        zIndex: 99999
      });
      
      // Show the dropdown
      $options.show();
      console.log('👕 [NAME FONT] Dropdown should be visible now');
      console.log('👕 [NAME FONT] Is visible?', $options.is(':visible'));
    } else {
      console.log('👕 [NAME FONT] ERROR: No options element found!');
    }
  });
  
  $(document).on('click', '.name-font-select-option', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('👕 [NAME FONT] Option selected:', $(this).find('img').attr('alt'));
    
    var optionType = $(this).data('type');
    if (optionType == 'adidas') {
      $("option[data-color-name-family*='adidas']").show();
      $("option[data-color-name-family='global']").hide();
      $("option[data-color-name-family*='adidas']").first().prop('selected', true);
    } else {
      $("option[data-color-name-family*='global']").show();
      $("option[data-color-name-family='adidas']").hide();
      $("option[data-color-name-family*='global']").first().prop('selected', true);
    }
    var value = $(this).data('value');
    var label = $(this).find('img').attr('alt');
    
    // Update the selected text
    $(this).closest('.select').find('.name-font-select-selected').text(label);
    
    // Hide the options
    $(this).closest('.name-font-select-options').hide();
  });
  
  // Close dropdowns when clicking outside
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.name-font-select-selected, .name-font-select-options').length) {
      $('.name-font-select-options').hide();
    }
  });
  
  if (window.ProSoccerConfig && window.ProSoccerConfig.flags && window.ProSoccerConfig.flags.isAdidasCollection) {
    $("option[data-color-name-family*='adidas']").show();
    $("option[data-color-name-family='global']").hide();
  }
});

/* ========== Script Block 3 ========== */
$(document).ready(function () {
  let product_vendor = window.ProSoccerConfig.product.vendor;
  let bags = window.ProSoccerConfig.flags.isBags;
  let checkout_btn = $(".product-form__submit");
  let show_custom_info_box = $("#show_custom_info");
  let custom_info = $('.custom_info');
  var existing_item_min_quantity = window.ProSoccerConfig.cart.existingItemMinQuantity;
  checkout_btn.attr('disabled', 'disabled');
  $(document).on('change', '.adult .quantity__input, .youth .quantity__input, .product-form__quantity .quantity__input, .tags-holder .quantity__input', function () {
    var sum = existing_item_min_quantity || 0;
    
    // PRIMARY SELECTOR: .tags-holder .quantity__input (used everywhere)
    $('.tags-holder .quantity__input').each(function () {
      var value = parseFloat($(this).val());
      if (!isNaN(value) && value > 0) {
        sum += value;
      }
    });
    
    // FALLBACK: Check other selectors if tags-holder doesn't exist
    if ($('.tags-holder .quantity__input').length === 0) {
      $('.all_quantity .quantity__input, .product-form__quantity .quantity__input, .quantity__input').each(function () {
        var value = parseFloat($(this).val());
        if (!isNaN(value) && value > 0) {
          sum += value;
        }
      });
    }
    
    console.log('🔧 [UNIFIED] Total quantity:', sum, 'from existing:', existing_item_min_quantity);

    if (sum > 0) {
      checkout_btn.removeAttr('disabled');
    } else {
      checkout_btn.attr('disabled', 'disabled');
    }

    // FORCE checkbox reset first
    show_custom_info_box.attr('disabled', 'disabled');
    show_custom_info_box.prop('disabled', true);
    
    if (sum > 6) {
      console.log('🔧 [UNIFIED] Quantity > 6 (' + sum + '), ENABLING checkbox');
      show_custom_info_box.removeAttr('disabled');
      show_custom_info_box.prop('disabled', false);
      checkout_btn.removeAttr('disabled');
      if (show_custom_info_box.prop('checked')) {
        custom_info.slideDown();
      } else {
        // Auto-check and open custom_info when quantity first reaches 7+
        // This ensures jacket/pant Names & Numbers (inside custom_info) become visible
        show_custom_info_box.prop('checked', true);
        custom_info.css('display', 'block').hide().slideDown(300);
        console.log('🔧 [UNIFIED] Auto-checked custom_info for quantity > 6');
      }
    } else {
      console.log('🔧 [UNIFIED] Quantity <= 6 (' + sum + '), checking already class');
      if (!show_custom_info_box.hasClass('already')) {
        show_custom_info_box.prop('disabled', true);
        show_custom_info_box.attr('disabled', 'disabled');
        custom_info.slideUp();
      } else {
        console.log('🔧 [UNIFIED] Has already class, enabling anyway');
        show_custom_info_box.removeAttr('disabled');
        show_custom_info_box.prop('disabled', false);
      }
    }
    
    console.log('🔧 [UNIFIED] Final checkbox state - Disabled:', show_custom_info_box.prop('disabled'));
    
    // Handle BSS B2B quantity table highlighting
    setTimeout(function () {
      if ($('.bss-b2b-qty-table-row').length > 0) {
        $('.bss-b2b-qty-table-row').each(function () {
          var data_min = parseFloat($(this).attr('data-min'));
          var data_max = parseFloat($(this).attr('data-max'));
          if (sum >= data_min && sum <= data_max) {
            var c = $(this);
            $('.bss-b2b-qty-table-row.qty-row-active').removeClass('qty-row-active');
            c.addClass('qty-row-active');
          }
        });
      }
    }, 100);

    // ROSTER GENERATION CODE continues here...
    var newValue = $(this).val();
    var size_tag = $(this).attr('size_tag');
    if (newValue == 0) {
      $('.player_number_name .adult_customizations .' + size_tag).hide();
    }
    else {
      $('.player_number_name .adult_customizations .' + size_tag).show();
    }
    var target = $('.player_number_name .adult_customizations .' + size_tag).children('div').eq(1);
    target.empty();
    
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
    
    var showNum = selectedFrontNumberValue == "yes" || selectedBackNumberValue == "yes";
    var showName = selectedNameValue == "yes";
    
    // Only generate roster rows if options are selected (no helper messages)
    if (showNum || showName) {
      for (var i = 0; i < newValue; i++) {
        var rosterHtml = '<div class="roster-row"><div class="roster-mini-label">Player ' + (i + 1) + '</div><div class="roster-grid' + (showNum && showName ? ' cols-2' : '') + '">';
        if (showName) {
          rosterHtml += '<div class="roster-field"><input form="' + window.ProSoccerConfig.product.formId + '" name="properties[name-Adult_' + size_tag + '-' + i + ']" class="input__field player_name" placeholder="MESSI" type="text" style="text-transform:uppercase;" value=""><span class="roster-price">$7.00</span></div>';
        }
        if (showNum) {
          rosterHtml += '<div class="roster-field"><input form="' + window.ProSoccerConfig.product.formId + '" name="properties[number-Adult_' + size_tag + '-' + i + ']" class="input__field player_number" min="0" placeholder="e.g. 10" onkeypress="handleOnlyTwoCharacters(event)" type="number" style="text-align:center;" value=""><span class="roster-price">$5.00</span></div>';
        }
        rosterHtml += '</div></div>';
        target.append(rosterHtml);
      }
    }
    
    // Trigger price updates after roster generation
    setTimeout(updateAllDynamicPricing, 100);
  });
});

/* ========== Script Block 5 ========== */
$(document).ready(function () {
  $(document).on('change', '.youth .quantity__input, .tags-holder .quantity__input', function () {
    var newValue = $(this).val();
    var size_tag = $(this).attr('size_tag');
    if (newValue == 0) {
      $('.player_number_name .youth_customizations .' + size_tag).hide();
    }
    else {
      $('.player_number_name .youth_customizations .' + size_tag).show();
    }
    var target = $('.player_number_name .youth_customizations .' + size_tag).children('div').eq(1);
    target.empty();
    
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
    
    var showNum = selectedFrontNumberValue == "yes" || selectedBackNumberValue == "yes";
    var showName = selectedNameValue == "yes";
    
    // Only generate roster rows if options are selected (no helper messages)
    if (showNum || showName) {
      for (var i = 0; i < newValue; i++) {
        var rosterHtml = '<div class="roster-row"><div class="roster-mini-label">Player ' + (i + 1) + '</div><div class="roster-grid' + (showNum && showName ? ' cols-2' : '') + '">';
        if (showName) {
          rosterHtml += '<div class="roster-field"><input form="' + window.ProSoccerConfig.product.formId + '" name="properties[name-Youth_' + size_tag + '-' + i + ']" class="input__field player_name" placeholder="MESSI" type="text" style="text-transform:uppercase;" value=""><span class="roster-price">$7.00</span></div>';
        }
        if (showNum) {
          rosterHtml += '<div class="roster-field"><input form="' + window.ProSoccerConfig.product.formId + '" name="properties[number-Youth_' + size_tag + '-' + i + ']" class="input__field player_number" min="0" placeholder="e.g. 10" onkeypress="handleOnlyTwoCharacters(event)" type="number" style="text-align:center;" value=""><span class="roster-price">$5.00</span></div>';
        }
        rosterHtml += '</div></div>';
        target.append(rosterHtml);
      }
    }
    
    // Trigger price updates after roster generation
    setTimeout(updateAllDynamicPricing, 100);

    if ($('#show_custom_info').hasClass('already')) {
      $('button[type="submit"]').removeAttr('disabled');
      console.log("Already Class exists");
    }
  });

  // Handle show_custom_info checkbox - both change and click events
  $('#show_custom_info').on('change click', function (e) {
    console.log('Checkbox event:', e.type, 'Checked:', $(this).prop('checked'), 'Disabled:', $(this).prop('disabled'));
    
    var isChecked = $(this).prop('checked');
    var isDisabled = $(this).prop('disabled');
    
    if (isDisabled) {
      console.log('Checkbox is disabled, not showing');
      return;
    }
    
    if (isChecked) {
      console.log('Showing custom_info with slideDown');
      $('.custom_info').css('display', 'block').hide().slideDown(300);
    } else {
      console.log('Hiding custom_info with slideUp');
      $('.custom_info').slideUp(300);
    }
    
    if (typeof updateButtonState === 'function') {
      updateButtonState();
    }
  });

  $('input[name="properties[showCrestLogoDropzone]"]').click(function () {
    var selectedValue = $('input[name="properties[showCrestLogoDropzone]"]:checked').val();
    if (selectedValue == "no") {
      $('.custom_crest_logo').hide();
    } else {
      $('.custom_crest_logo').show();
    }
  });

  $('input[name="properties[showChestType]"]').click(function () {
    var selectedValue = $('input[name="properties[showChestType]"]:checked').val();
    console.log(selectedValue);
    if (selectedValue == "no") {
      $('.custom_chest_logo').hide();
    }
    if (selectedValue == "yes") {
      $('.custom_chest_logo').show();
    }
  });

  $('input[name="properties[jerseySleeveLogoEnable]"]').click(function () {
    var isYes = $('input[name="properties[jerseySleeveLogoEnable]"]:checked').val() === 'yes';
    isYes ? $('.sleeve_logo_upload').show() : $('.sleeve_logo_upload').hide();
    isYes ? $('.sleeve_logo_type_section').show() : $('.sleeve_logo_type_section').hide();
  });

  // Top sleeve logo toggle
  $('input[name="properties[topSleeveLogoEnable]"]').click(function () {
    var isYes = $('input[name="properties[topSleeveLogoEnable]"]:checked').val() === 'yes';
    isYes ? $('.top_sleeve_logo_upload').show() : $('.top_sleeve_logo_upload').hide();
    isYes ? $('.top_sleeve_logo_type_section').show() : $('.top_sleeve_logo_type_section').hide();
  });

  // Jacket sleeve logo toggle
  $('input[name="properties[jacketSleeveLogoEnable]"]').click(function () {
    var isYes = $('input[name="properties[jacketSleeveLogoEnable]"]:checked').val() === 'yes';
    isYes ? $('.jacket_sleeve_logo_upload').show() : $('.jacket_sleeve_logo_upload').hide();
    isYes ? $('.jacket_sleeve_logo_type_section').show() : $('.jacket_sleeve_logo_type_section').hide();
  });

  // Hoodie sleeve logo toggle
  $('input[name="properties[hoodieSleeveLogoEnable]"]').click(function () {
    var isYes = $('input[name="properties[hoodieSleeveLogoEnable]"]:checked').val() === 'yes';
    isYes ? $('.hoodie_sleeve_logo_upload').show() : $('.hoodie_sleeve_logo_upload').hide();
    isYes ? $('.hoodie_sleeve_logo_type_section').show() : $('.hoodie_sleeve_logo_type_section').hide();
  });

  $('input[name="properties[jerseySponsorLogoEnable]"]').click(function () {
    $('input[name="properties[jerseySponsorLogoEnable]"]:checked').val() === 'yes'
      ? $('.sponsor_logo_upload').show()
      : $('.sponsor_logo_upload').hide();
  });

  // Team Name on Back — Jersey only
  $('input[name="properties[jerseyTeamNameEnable]"]').on('change', function () {
    var isYes = $(this).val() === 'yes';
    isYes ? $('.jersey_team_name_holder').slideDown() : $('.jersey_team_name_holder').slideUp();

    // If switching to No and fee product was already in cart — zero it out
    if (!isYes) {
      var alreadyInCart = $('#alreadyJerseyTeamNameItem').val();
      if (alreadyInCart === 'yes') {
        var fd = new FormData();
        fd.append('updates[52243868385582]', 0);
        fetch('/cart/update.js', { method: 'POST', body: fd })
          .then(function () {
            $('#alreadyJerseyTeamNameItem').val('no');
            $('#alreadyJerseyTeamNameTotal').val('0');
          })
          .catch(function (e) { console.error('Team name remove error:', e); });
      }
    }
  });

  // PS Custom Logo toggle
  $('input[name="properties[PS Custom Logo]"]').on('change', function () {
    var isYes = $(this).val() === 'yes';
    isYes ? $('.jersey_ps_logo_position_holder').slideDown() : $('.jersey_ps_logo_position_holder').slideUp();
    isYes ? $('#jersey_ps_preview').addClass('show') : $('#jersey_ps_preview').removeClass('show');
    isYes ? $('#jersey_ps_image_preview').addClass('show') : $('#jersey_ps_image_preview').removeClass('show');
  });

  $('input[name="properties[frontNumber]"]').click(function () {
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
    syncJerseyNameNumberSections();

    console.log(selectedFrontNumberValue);
    if (selectedFrontNumberValue == "no") {
      $('.front_number').hide();
    }
    if (selectedFrontNumberValue == "yes") {
      $('.front_number').show();
    }

    // Show/hide player_number_name section based on selections
    if (selectedFrontNumberValue == "yes" || selectedNameValue == "yes" || selectedBackNumberValue == "yes") {
      $(".player_number_name").show();
    } else {
      $(".player_number_name").hide();
    }

    // Trigger quantity input change to regenerate roster rows
    $('.adult .quantity__input, .youth .quantity__input').trigger('change');

  });

  $('input[name="properties[lastName]"]').click(function () {
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();

    console.log('lastName clicked:', selectedNameValue);
    syncJerseyNameNumberSections();

    // Show/hide player_number_name section based on selections
    if (selectedFrontNumberValue == "yes" || selectedNameValue == "yes" || selectedBackNumberValue == "yes") {
      $(".player_number_name").show();
    } else {
      $(".player_number_name").hide();
    }

    // Trigger quantity input change to regenerate roster rows
    console.log('Triggering quantity change to regenerate roster');
    var quantityInputs = $('.adult .quantity__input, .youth .quantity__input');
    console.log('Found quantity inputs:', quantityInputs.length);
    quantityInputs.each(function() {
      var val = $(this).val();
      if (val > 0) {
        console.log('Triggering change for input with value:', val);
        $(this).trigger('change');
      }
    });
  });

  $('input[name="properties[backNumberSize]"]').click(function () {
    var selectedFrontNumberValue = $('input[name="properties[frontNumber]"]:checked').val();
    var selectedNameValue = $('input[name="properties[lastName]"]:checked').val();
    var selectedBackNumberValue = $('input[name="properties[backNumberSize]"]:checked').val();
    syncJerseyNameNumberSections();

    console.log(selectedBackNumberValue);
    if (selectedBackNumberValue == "no") {
      $('.back_number_size').hide();
    }
    if (selectedBackNumberValue == "yes") {
      $('.back_number_size').show();
    }

    if (selectedFrontNumberValue == "yes" || selectedNameValue == "yes" || selectedBackNumberValue == "yes") {
      $(".player_number_name").show();
    }

    if (selectedFrontNumberValue == "no" && selectedNameValue == "no" && selectedBackNumberValue == "no") {
      $(".player_number_name").hide();
    }

    if (selectedFrontNumberValue == "yes" || selectedBackNumberValue == "yes") {
      $(".player_number_input").show();
    }

    if (selectedFrontNumberValue == "no" && selectedBackNumberValue == "no") {
      $(".player_number_input").hide();
    }

    if (selectedNameValue == "yes") {
      $(".player_name_input").show();
    }
    
    // Trigger quantity input change to regenerate roster rows
    $('.adult .quantity__input, .youth .quantity__input').trigger('change');
  });

  $('.player_name_shape select').change(function () {
    var selectedValue = $(this).val();
    console.log(selectedValue);
    if (selectedValue == "Straight") {
      $('.arc_number').hide();
      $('.straight_number').show();
    }
    if (selectedValue == "Arc") {
      $('.straight_number').hide();
      $('.arc_number').show();
    }
  });


});

/* ========== Script Block 4 - REMOVED (CONSOLIDATED INTO UNIFIED SYSTEM) ========== */

/* ========== Script Block 5 ========== */
function addToCart(variantId, properties, quantity, callback) {
  // Construct the data object with variant ID, properties, and quantity
  var data = {
    id: variantId,
    properties: properties,
    quantity: quantity
  };

  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    data: data,
    dataType: 'json',
    success: function (response) {
      callback(null, response);
    },
    error: function (xhr, status, error) {
      callback(error);
    }
  });
}

$(document).ready(function () {
  // Attach an event listener to the "Add to Cart" button

  // Non-customizable product handler (for products without customization checkbox)
  $(document).on('click', '.product-form__submit', function (e) {
    
    // Check if this is a customizable product - if so, let the other handler deal with it
    var customInfoElement = $('#show_custom_info');
    if (customInfoElement.length > 0) {
      console.log("🔵 [NON-CUSTOM HANDLER] Skipping - customization checkbox exists, other handler will process");
      return; // Let the customizable handler deal with it
    }
    
    e.preventDefault();
    e.stopImmediatePropagation();

    console.log("🔵 [NON-CUSTOM HANDLER] Processing non-customizable product");

    if ($('.player_number_name input.player_name:visible').filter((_, el) => !el.value.trim()).length) {
      alert('Player name cannot be empty');
      return false;
    }
    if ($('.player_number_name input.player_number:visible').filter((_, el) => !el.value.trim()).length) {
      alert('Player Number cannot be empty');
      return false;
    }

    let emptyInput = $('.logo_holder:visible input[type="file"]').toArray().find(input => input.files.length === 0);
    if (emptyInput) {
      alert($(emptyInput).data('message') || 'Please select all required files.');
      return false;
    }

    $(this).addClass('loading');
    $(this).prop('disabled', true);
    var cartItems = [];
    $('.tags-holder .quantity__input').each(function () {
      var variantId = $('input[name="id"]').val();
      var quantity = parseFloat($(this).val()); // Set the quantity as desired
      var properties = {};
      properties[window.ProSoccerConfig.flags.socksSizeTagFound ? 'Sock Size' : 'Size'] = $(this).attr('size_tag');
      console.log(properties);
      if (quantity > 0) {
        var item = { 'variantId': variantId, 'quantity': quantity, 'properties': properties };
        cartItems.push(item);
      }
    });

    // Validate that at least one size is selected
    if (cartItems.length === 0) {
      alert('Please select at least one size and quantity');
      $(this).removeClass('loading');
      $(this).prop('disabled', false);
      return false;
    }

    function addItemsToCartSequentially(index) {
      if (index >= cartItems.length) {
        console.log('Added in Cart');
        localStorage.setItem('triggerAction', 'true');
        location.replace(location.href);
        return;
      }

      var item = cartItems[index];
      addToCart(item.variantId, item.properties, item.quantity, function (error, response) {
        if (error) {
          console.error('Error adding item to cart:', error);
          // Handle the error condition
        } else {
          console.log('Item added to cart:', response);
          // Move to the next item
          addItemsToCartSequentially(index + 1);
        }
      });
    }

    addItemsToCartSequentially(0);

  });
});

/* ========== Script Block 6 ========== */
function addToCart(variantId, properties, quantity, callback) {
  var data = {
    id: variantId,
    properties: properties,
    quantity: quantity
  };

  $.ajax({
    url: '/cart/add.js',
    method: 'POST',
    data: data,
    dataType: 'json',
    success: function (response) {
      callback(null, response);
    },
    error: function (xhr, status, error) {
      callback(error);
    }
  });
}

$(document).ready(function () {
  console.log("ready working for bag");
  var globalProductId = window.ProSoccerConfig.product.id;
  var CartVectorLogoKeys = window.ProSoccerConfig.cart.vectorLogoKeys;
  var vectorLogoKeys = CartVectorLogoKeys.split(',').map(s => s.trim()).filter(Boolean) || [];
  $(document).on('click', '.product-form__submit', function (e) {

    e.preventDefault();
    console.log("🔵 [ADD TO CART] Click handler started");
    console.log("🔵 [ADD TO CART] customInfoElement checked:", $('#show_custom_info').prop('checked'));
    console.log("🔵 [ADD TO CART] customInfoElement disabled:", $('#show_custom_info').prop('disabled'));

    if ($('.player_number_name input.player_name:visible').filter((_, el) => !el.value.trim()).length) {
      alert('Player name cannot be empty');
      return false;
    }
    if ($('.player_number_name input.player_number:visible').filter((_, el) => !el.value.trim()).length) {
      alert('Player Number cannot be empty');
      return false;
    }

    let emptyInput = $('.logo_holder:visible input[type="file"]').toArray().find(input => input.files.length === 0);
    if (emptyInput) {
      alert($(emptyInput).data('message') || 'Please select all required files.');
      return false;
    }

    $(this).addClass('loading');
    $(this).prop('disabled', true);
    
    console.log("🔵 [ADD TO CART] Starting cart item collection");

    var cartItems = [];
    var productDetails = [];
    var CartUpdateItems = [];

    var apply_vector_fee = false;
    var count_of_crest_logo = 0;
    var count_of_chest_logo = 0;
    var count_of_front_number = 0;
    var count_of_back_number = 0;
    var count_of_custom_name = 0;


    var count_of_pant_number = 0;
    var count_of_pant_crest_logos = 0;
    var total_pant_heat_press_crest_logos = 0;
    var total_pant_embroidery_crest_logos = 0;

    var count_of_short_front_number = 0;

    var count_of_jacket_number = 0;
    var count_of_jacket_name = 0;
    var count_of_jacket_crest_logos = 0;
    var total_jacket_heat_press_crest_logos = 0;
    var total_jacket_embroidery_crest_logos = 0;

    var count_of_top_crest_logos = 0;
    var total_top_heat_press_crest_logos = 0;
    var total_top_embroidery_crest_logos = 0;

    var count_of_top_chest_logos = 0;
    var total_top_heat_press_chest_logos = 0;
    var total_top_embroidery_chest_logos = 0;

    var count_of_hoodie_number = 0;
    var count_of_hoodie_name = 0;

    var count_of_top_number = 0;
    var count_of_top_name = 0;

    var count_of_cap_crest_logos = 0;
    var total_cap_embroidery_crest_logos = 0;

    var count_of_hoodie_crest_logos = 0;
    var total_hoodie_heat_press_crest_logos = 0;
    var total_hoodie_embroidery_crest_logos = 0;

    var count_of_hoodie_chest_logos = 0;
    var total_hoodie_heat_press_chest_logos = 0;
    var total_hoodie_embroidery_chest_logos = 0;

    var count_of_bag_number = 0;
    var count_of_bag_name = 0;
    var count_of_bag_crest_logos = 0;

    var total_bag_heat_press_crest_logos = 0;
    var total_bag_embroidery_crest_logos = 0;

    var count_of_jersey_sleeve_logo = 0;
    var count_of_jersey_sponsor_logo = 0;
    var count_of_jersey_team_name = 0;


    $('.tags-holder .quantity__input').each(function () {
      
      console.log("🟢 [SIZE LOOP] Processing size:", $(this).attr('size_tag'), "quantity:", $(this).val());

      var line_count_of_back_number = 0;
      var line_count_of_front_number = 0;
      var line_count_of_custom_name = 0;

      var line_count_of_top_number = 0;
      var line_count_of_top_name = 0;
      var line_count_of_pant_number = 0;

      var line_count_of_short_front_number = 0;

      var line_count_of_hoodie_number = 0;
      var line_count_of_hoodie_name = 0;

      var line_count_of_jacket_number = 0;
      var line_count_of_jacket_name = 0;

      var line_count_of_bag_number = 0;
      var line_count_of_bag_name = 0;

      var customInfoElement = $('#show_custom_info');
      var variantId = $('input[name="id"]').val();
      var quantity = parseFloat($(this).val());
      
      console.log("🟢 [SIZE LOOP] variantId:", variantId, "quantity:", quantity);
      
      if (quantity > 0 && !isNaN(quantity)) {

        var size = $(this).attr('size_tag');  // Fixed: use size_tag instead of name
        var properties = {};
        properties[window.ProSoccerConfig.flags.socksSizeTagFound ? 'Sock Size' : 'Size'] = size;
        var lastNameEnable = $('input[name="properties[lastName]"]:checked').val();
        if (typeof lastNameEnable !== 'undefined') {
          properties['Last Name'] = lastNameEnable;
        }
        var topLastNameEnable = $('input[name="properties[TopLastName]"]:checked').val();
        if (typeof topLastNameEnable !== 'undefined') {
          properties['Top Last Name'] = topLastNameEnable;
        }
        
        console.log("🟢 [SIZE LOOP] Processing customization check for size:", size);
        console.log("🟢 [SIZE LOOP] Checkbox checked:", customInfoElement.prop('checked'), "disabled:", customInfoElement.prop('disabled'));

        if (customInfoElement.prop('checked') && (customInfoElement.prop('disabled') == false)) {

          console.log("✅ [CUSTOMIZATION] Customization enabled for size:", size);
          var productItem = {};
          productItem.variantId = variantId;
          productItem.quantity = quantity;

          // start logo management

          // ========================================================================================
          // ENHANCED FILE DETECTION SYSTEM - INTEGRATED
          // Comprehensive file detection from ALL customization types
          // ========================================================================================

          console.log('🔍 [LOGO DETECTION] Starting search for uploaded logo files...');
          
          // Use our logo file detection function
          const detectedFiles = getUploadedLogoFiles();
          const { crestLogoFile, chestLogoFile, psLogoFile } = detectedFiles;

          // PRESERVE detected files in productItem - DO NOT let individual product logic overwrite these
          productItem.crestLogoFile = crestLogoFile;
          productItem.chestLogoFile = chestLogoFile;
          productItem.psLogoFile = psLogoFile;
          var sleeveLogoFileInput = $('#sleeve_logo_file, #top_sleeve_logo_file, #jacket_sleeve_logo_file, #hoodie_sleeve_logo_file')
            .filter(function(){ return this.files && this.files.length > 0; })
            .get(0);
          productItem.sleeveLogoFile = sleeveLogoFileInput?.files?.[0]
            ?? window.uploadedLogoFiles?.sleeveLogoFile
            ?? null;
          productItem.sponsorLogoFile = $('#sponsor_logo_file')[0]?.files?.[0] ?? null;

          // Debug: Show what we detected
          console.log('🎯 [PRODUCTITEM] Files assigned:', {
            crestLogoFile: productItem.crestLogoFile?.name || 'null',
            chestLogoFile: productItem.chestLogoFile?.name || 'null',
            psLogoFile: productItem.psLogoFile?.name || 'null'
          });

          // ========================================================================================
          // JERSEY SPECIFIC DEBUG - Check jersey customization state
          // ========================================================================================
          var crest_logo_enable = $('input[name="properties[showCrestLogoDropzone]"]:checked').val();
          var chest_logo_enable = $('input[name="properties[showChestType]"]:checked').val();
          
          console.log('🏆 [JERSEY DEBUG] Customization State:', {
            crest_logo_enable: crest_logo_enable,
            chest_logo_enable: chest_logo_enable,
            crest_logo_element: $('#crest_logo')[0] ? 'exists' : 'missing',
            crest_logo_2_element: $('#crest_logo_2')[0] ? 'exists' : 'missing',
            chest_logo_element: $('#chest_logo')[0] ? 'exists' : 'missing',
            crest_logo_files: $('#crest_logo')[0]?.files?.length || 0,
            crest_logo_2_files: $('#crest_logo_2')[0]?.files?.length || 0,
            chest_logo_files: $('#chest_logo')[0]?.files?.length || 0
          });
          
          if (crest_logo_enable) properties['Crest Logo'] = crest_logo_enable;


          // ---------------- Jacket Crest ----------------
          var jacketCrestType = $('input[name="properties[JacketCrestLogoType]"]:checked').data('name')?.trim();
          if (jacketCrestType && jacketCrestType.toLowerCase() !== 'no') {
            properties['Jacket Logo Type'] = jacketCrestType;
            // ✅ File already detected and set above - DO NOT overwrite
            // productItem.crestLogoFile = crestLogoFile; // REMOVED to preserve enhanced detection

            jacketCrestType == 'Heat Press'
              ? total_jacket_heat_press_crest_logos += quantity
              : total_jacket_embroidery_crest_logos += quantity;

            count_of_jacket_crest_logos += quantity;
            var crestName = productItem.crestLogoFile?.name ?? ''; // Use productItem instead of crestLogoFile
            if (crestName) vectorLogoKeys.push(crestName + '|' + jacketCrestType);
            apply_vector_fee = true;
          }


          // ---------------- Pant Crest ----------------
          var pantCrestType = $('input[name="properties[pantCrestLogoType]"]:checked').data('name')?.trim();
          if (pantCrestType && pantCrestType.toLowerCase() !== 'no') {
            properties['Pant Logo Type'] = pantCrestType;
            productItem.crestLogoFile = crestLogoFile;

            pantCrestType == 'Heat Press'
              ? total_pant_heat_press_crest_logos += quantity
              : total_pant_embroidery_crest_logos += quantity;

            count_of_pant_crest_logos += quantity;
            var crestName = crestLogoFile?.name ?? '';
            if (crestName) vectorLogoKeys.push(crestName + '|' + pantCrestType);
            apply_vector_fee = true;
          }
          // ---------------- Top Crest ----------------
          var topCrestType = $('input[name="properties[TopCrestLogoType]"]:checked').data('name')?.trim();
          if (topCrestType && topCrestType.toLowerCase() !== 'no') {
            properties['Top Crest Logo Type'] = topCrestType;
            productItem.crestLogoFile = crestLogoFile;
            topCrestType == 'Heat Press'
              ? total_top_heat_press_crest_logos += quantity
              : total_top_embroidery_crest_logos += quantity;

            count_of_top_crest_logos += quantity;
            var crestName = crestLogoFile?.name ?? '';
            if (crestName) vectorLogoKeys.push(crestName + '|' + topCrestType);
            apply_vector_fee = true;
          }

          // ---------------- Top Chest ----------------
          var topChestType = $('input[name="properties[TopChestLogoType]"]:checked').data('name')?.trim();
          if (topChestType && topChestType.toLowerCase() !== 'no') {
            properties['Top Chest Logo Type'] = topChestType;
            productItem.chestLogoFile = chestLogoFile;

            topChestType == 'Heat Press'
              ? total_top_heat_press_chest_logos += quantity
              : total_top_embroidery_chest_logos += quantity;

            count_of_top_chest_logos += quantity;
            var chestName = chestLogoFile?.name ?? '';
            if (chestName) vectorLogoKeys.push(chestName + '|' + topChestType);
            apply_vector_fee = true;
          }

          // ---------------- Cap Crest ----------------
          var capCrestType = $('input[name="properties[CapCrestLogoType]"]:checked').data('name')?.trim();
          if (capCrestType && capCrestType !== 'no') {
            properties['Cap Crest Logo Type'] = capCrestType;
            productItem.crestLogoFile = crestLogoFile;
            total_cap_embroidery_crest_logos += quantity;
            count_of_cap_crest_logos += quantity;
            var crestName = crestLogoFile?.name ?? '';
            if (crestName) vectorLogoKeys.push(crestName + '|' + capCrestType);
            apply_vector_fee = true;
          }


          // ---------------- Hoodie Crest ----------------
          var hoodieCrestType = $('input[name="properties[HoodieCrestLogoType]"]:checked').data('name')?.trim();
          if (hoodieCrestType && hoodieCrestType !== 'no') {
            properties['Hoodie Crest Logo Type'] = hoodieCrestType;
            productItem.crestLogoFile = crestLogoFile;
            hoodieCrestType == 'Heat Press'
              ? total_hoodie_heat_press_crest_logos += quantity
              : total_hoodie_embroidery_crest_logos += quantity;
            count_of_hoodie_crest_logos += quantity;
            var crestName = crestLogoFile?.name ?? '';
            if (crestName) vectorLogoKeys.push(crestName + '|' + hoodieCrestType);
            apply_vector_fee = true;
          }


          // ---------------- Hoodie Chest ----------------
          var hoodieChestType = $('input[name="properties[HoodieChestLogoType]"]:checked').data('name')?.trim();
          if (hoodieChestType && hoodieChestType !== 'no') {
            properties['Hoodie Chest Logo Type'] = hoodieChestType;
            productItem.chestLogoFile = chestLogoFile;

            hoodieChestType == 'Heat Press'
              ? total_hoodie_heat_press_chest_logos += quantity
              : total_hoodie_embroidery_chest_logos += quantity;

            count_of_hoodie_chest_logos += quantity;
            var chestName = chestLogoFile?.name ?? '';
            if (chestName) vectorLogoKeys.push(chestName + '|' + hoodieChestType);
            apply_vector_fee = true;
          }


          // ---------------- Bag Crest ----------------
          var $bag = $('input[name="properties[bagCrestLogoType]"]:checked');
          var bagCrestType = $bag.data('name')?.trim();

          if (bagCrestType && bagCrestType !== 'no') {
            properties['Bag Logo Type'] = bagCrestType;
            properties['Bag Logo Id'] = $bag.val();
            properties['productId'] = window.ProSoccerConfig.product.id;

            productItem.crestLogoFile = crestLogoFile;

            bagCrestType == 'Heat Press'
              ? total_bag_heat_press_crest_logos += quantity
              : total_bag_embroidery_crest_logos += quantity;

            count_of_bag_crest_logos += quantity;
            var crestName = crestLogoFile?.name ?? '';
            if (crestName) vectorLogoKeys.push(crestName + '|' + bagCrestType);
            apply_vector_fee = true;
          }
          // ---------------- Crest Toggle ----------------
          if (crest_logo_enable && crest_logo_enable !== "no") {
            count_of_crest_logo += quantity;
            var crestName = crestLogoFile?.name ?? '';
            var crestStyle = (crest_logo_enable === '52049128489262') ? 'Heat Press'
              : (crest_logo_enable === '52049122328878') ? 'Embroidery'
                : 'Standard';
            if (crestName) vectorLogoKeys.push(crestName + '|' + crestStyle);
            apply_vector_fee = true;
            properties['Crest Logo Variant Id'] = crest_logo_enable;
          }
          // ---------------- Chest Toggle ----------------
          var showChestType = $('input[name="properties[showChestType]"]:checked').val();
          if (showChestType) properties['Chest Type'] = showChestType;

          if (showChestType == "yes") {
            count_of_chest_logo += quantity;
            var chestName = chestLogoFile?.name ?? '';
            if (chestName) vectorLogoKeys.push(chestName + '|Standard');
            apply_vector_fee = true;
          }

          // end logo management

          //small number conditoins start
          var shortFrontNumberEnable = "no";
          var topSmallNumberEnable = "no";
          var bagSmallNumberEnable = "no";
          var pantSmallNumberEnable = "no";
          var jacketSmallNumberEnable = "no";
          var hoodieSmallNumberEnable = "no";
          var bagNameEnable = "no";

          let numberFontColor = $('select[name="properties[Number Font Color]"]').val();

          // Manage Short Number Enable
          let shortFrontNumber = $('input[name="properties[shortFrontNumber]"]:checked');
          let shortFrontNumberVariantId = shortFrontNumber.val();
          if (shortFrontNumber.length && shortFrontNumberVariantId !== undefined && shortFrontNumberVariantId !== 'no') {
            properties['Short Number'] = 'yes';
            properties['Short Number Variant Id'] = shortFrontNumberVariantId;
            shortFrontNumberEnable = 'yes';
          }

          /* Manage Bag Name and Number */
          let bagSmallNumber = $('input[name="properties[bagSmallNumber]"]:checked');
          let bagSmallNumberFor = bagSmallNumber.data('name');
          let bagSmallNumberVariantId = bagSmallNumber.val();
          if (bagSmallNumberFor && bagSmallNumberVariantId !== 'no') {
            properties['Bag Small Number'] = 'yes';
            properties['Bag Small Number For'] = bagSmallNumberFor;
            properties['Bag Small Number Variant Id'] = bagSmallNumberVariantId;
            bagSmallNumberEnable = 'yes';
          }
          let bagName = $('input[name="properties[bagName]"]:checked');
          let bagNameFor = bagName.data('name');
          let bagNameVariantId = bagName.val();
          if (bagNameFor && bagNameVariantId !== 'no') {
            properties['Bag Name'] = 'yes';
            properties['Bag Name For'] = bagNameFor;
            properties['Bag Name Variant Id'] = bagNameVariantId;
            bagNameEnable = 'yes';
          }

          /* TOP */
          let topSmallNumber = $('input[name="properties[topSmallNumber]"]:checked');
          let topSmallNumberFor = topSmallNumber.data('name');
          let topSmallNumberVariantId = topSmallNumber.val();

          if (topSmallNumberFor && topSmallNumberVariantId !== 'no') {
            properties['Top Small Number'] = 'yes';
            properties['Top Small Number For'] = topSmallNumberFor;
            properties['Top Small Number Variant Id'] = topSmallNumberVariantId;
            properties['Number Font Color'] = numberFontColor;
            topSmallNumberEnable = "yes";
          }
          /* PANT */
          let pantSmallNumber = $('input[name="properties[pantSmallNumber]"]:checked');
          let pantSmallNumberFor = pantSmallNumber.data('name');
          let pantSmallNumberVariantId = pantSmallNumber.val();

          if (pantSmallNumberFor && pantSmallNumberVariantId !== 'no') {
            properties['Pant Small Number'] = 'yes';
            properties['Pant Small Number For'] = pantSmallNumberFor;
            properties['Pant Small Number Variant Id'] = pantSmallNumberVariantId;
            properties['Number Font Color'] = numberFontColor;
            pantSmallNumberEnable = "yes";
          }

          /* JACKET */
          let jacketSmallNumber = $('input[name="properties[jacketSmallNumber]"]:checked');
          let jacketSmallNumberFor = jacketSmallNumber.data('name');
          let jacketSmallNumberVariantId = jacketSmallNumber.val();

          if (jacketSmallNumberFor && jacketSmallNumberVariantId !== 'no') {
            properties['Jacket Small Number'] = 'yes';
            properties['Jacket Small Number For'] = jacketSmallNumberFor;
            properties['Jacket Small Number Variant Id'] = jacketSmallNumberVariantId;
            properties['Number Font Color'] = numberFontColor;
            jacketSmallNumberEnable = "yes";
          }

          /* HOODIE */
          let hoodieSmallNumber = $('input[name="properties[hoodieSmallNumber]"]:checked');
          let hoodieSmallNumberFor = hoodieSmallNumber.data('name');
          let hoodieSmallNumberVariantId = hoodieSmallNumber.val();

          if (hoodieSmallNumberFor && hoodieSmallNumberVariantId !== 'no') {
            properties['Hoodie Small Number'] = 'yes';
            properties['Hoodie Small Number For'] = hoodieSmallNumberFor;
            properties['Hoodie Small Number Variant Id'] = hoodieSmallNumberVariantId;
            properties['Number Font Color'] = numberFontColor;
            hoodieSmallNumberEnable = "yes";
          }

          if (topLastNameEnable == "yes") {
            properties['Player Name Shape'] = $('select[name="properties[Player Name Shape]"]').val();
                        (function(){ var $pnfSelect = $('.font-img-select').filter(function(){ return $(this).find('input.font-img-value[name*="Name Font"]').length > 0; }).first(); properties['Player Name Font'] = $pnfSelect.find('.font-img-trigger-text').text().trim() || $pnfSelect.find('.font-img-option.selected').data('label') || ''; })();
            properties['Last Name Font Color'] = $('select[name="properties[Last Name Font Color]"]').val();

          }

          var jacketLastNameEnable = $('input[name="properties[jacketLastName]"]:checked').val();
          if (typeof jacketLastNameEnable !== 'undefined') {
            properties['Jacket Last Name'] = jacketLastNameEnable;
          }
          if (jacketLastNameEnable == "yes") {
            properties['Player Name Shape'] = $('select[name="properties[Player Name Shape]"]').val();
                        (function(){ var $pnfSelect = $('.font-img-select').filter(function(){ return $(this).find('input.font-img-value[name*="Name Font"]').length > 0; }).first(); properties['Player Name Font'] = $pnfSelect.find('.font-img-trigger-text').text().trim() || $pnfSelect.find('.font-img-option.selected').data('label') || ''; })();
            properties['Last Name Font Color'] = $('select[name="properties[Last Name Font Color]"]').val();
          }


          var hoodieLastNameEnable = $('input[name="properties[HoodieLastName]"]:checked').val();
          if (typeof hoodieLastNameEnable !== 'undefined') {
            properties['Hoodie Last Name'] = hoodieLastNameEnable;
          }
          if (hoodieLastNameEnable == "yes") {
            properties['Player Name Shape'] = $('select[name="properties[Player Name Shape]"]').val();
                        (function(){ var $pnfSelect = $('.font-img-select').filter(function(){ return $(this).find('input.font-img-value[name*="Name Font"]').length > 0; }).first(); properties['Player Name Font'] = $pnfSelect.find('.font-img-trigger-text').text().trim() || $pnfSelect.find('.font-img-option.selected').data('label') || ''; })();
            properties['Last Name Font Color'] = $('select[name="properties[Last Name Font Color]"]').val();
          }

          var frontNumberEnable = $('input[name="properties[frontNumber]"]:checked').val();
          if (typeof frontNumberEnable !== 'undefined') {
            properties['Front Number'] = frontNumberEnable;
          }

          // Back Number
          var backNumberEnable = $('input[name="properties[backNumberSize]"]:checked').val();
          if (typeof backNumberEnable !== 'undefined') {
            properties['Back Number'] = backNumberEnable;
          }

          var backNumberSize = $('select[name="properties[Back Number Size]"]').val();
          if (backNumberEnable == "yes") {
            properties['Back Number Size'] = backNumberSize;
            var $fontImgSelect = $('.font-img-select').filter(function(){ return $(this).find('input.font-img-value[name*="Number Font"]').length > 0; }).first();
            var numberFontLabel = $fontImgSelect.find('.font-img-trigger-text').text().trim() || $fontImgSelect.find('.font-img-option.selected').data('label') || '';
            properties['Jersey Number Font'] = numberFontLabel;
            properties['Font Color'] = $('select[name="properties[Font Color]"]').val();
          }

          if (lastNameEnable == "yes") {
            properties['Player Name Shape'] = $('select[name="properties[Player Name Shape]"]').val();
                        (function(){ var $pnfSelect = $('.font-img-select').filter(function(){ return $(this).find('input.font-img-value[name*="Name Font"]').length > 0; }).first(); properties['Player Name Font'] = $pnfSelect.find('.font-img-trigger-text').text().trim() || $pnfSelect.find('.font-img-option.selected').data('label') || ''; })();
            properties['Player Font Color'] = $('select[name="properties[Player Font Color]"]').val();
          }

          // ---------------- Jersey/Top/Jacket/Hoodie Sleeve Logo ($6) ----------------
          var sleeveLogoOptions = [
            { enableProperty: 'jerseySleeveLogoEnable', typeProperty: 'Sleeve Logo Type' },
            { enableProperty: 'topSleeveLogoEnable', typeProperty: 'Top Sleeve Logo Type' },
            { enableProperty: 'jacketSleeveLogoEnable', typeProperty: 'Jacket Sleeve Logo Type' },
            { enableProperty: 'hoodieSleeveLogoEnable', typeProperty: 'Hoodie Sleeve Logo Type' }
          ];
          var selectedSleeveLogoOption = sleeveLogoOptions.find(function(option) {
            return $('input[name="properties[' + option.enableProperty + ']"]:checked').val() === 'yes';
          });
          if (selectedSleeveLogoOption) {
            properties['Sleeve Logo'] = 'yes';
            var sleeveLogoTypeInput = $('input[name="properties[' + selectedSleeveLogoOption.typeProperty + ']"]:checked').val();
            if (sleeveLogoTypeInput) properties['Sleeve Logo Type'] = sleeveLogoTypeInput;
            var sleeveLogoFile = productItem.sleeveLogoFile;
            if (sleeveLogoFile) {
              properties['Sleeve Logo Name'] = sleeveLogoFile.name;
              vectorLogoKeys.push(sleeveLogoFile.name + '|Standard');
            }
            count_of_jersey_sleeve_logo += quantity;
            apply_vector_fee = true;
          }

          // ---------------- Jersey Sponsor/Team Logo ($10) ----------------
          var jerseySponsorLogoEnable = $('input[name="properties[jerseySponsorLogoEnable]"]:checked').val();
          if (jerseySponsorLogoEnable === 'yes') {
            properties['Sponsor/Team Logo'] = 'yes';
            var sponsorLogoPosition = $('input[name="properties[Sponsor Logo Position]"]:checked').val();
            if (sponsorLogoPosition) properties['Sponsor Logo Position'] = sponsorLogoPosition;
            var sponsorLogoFile = $('#sponsor_logo_file')[0]?.files?.[0] ?? null;
            if (sponsorLogoFile) {
              properties['Sponsor Logo Name'] = sponsorLogoFile.name;
              vectorLogoKeys.push(sponsorLogoFile.name + '|Standard');
            }
            count_of_jersey_sponsor_logo += quantity;
            apply_vector_fee = true;
          }

          // ---------------- Jersey Team Name on Back ----------------
          var jerseyTeamNameEnable = $('input[name="properties[jerseyTeamNameEnable]"]:checked').val();
          if (jerseyTeamNameEnable === 'yes') {
            properties['Team Name Enable'] = 'yes';
            var teamNamePosition = $('input[name="properties[Team Name Position]"]:checked').val();
            if (teamNamePosition) properties['Team Name Position'] = teamNamePosition;
            var teamNameFile = $('#team_logo_file')[0]?.files?.[0] ?? null;
            if (teamNameFile) {
              properties['Team Name File'] = teamNameFile.name;
              vectorLogoKeys.push(teamNameFile.name + '|Standard');
            }
            count_of_jersey_team_name += quantity;
            apply_vector_fee = true;
          }

          // ---------------- PS Custom Logo ----------------
          var psLogoEnable = $('input[name="properties[PS Custom Logo]"]:checked').val();
          if (psLogoEnable === 'yes') {
            properties['PS Custom Logo'] = 'yes';
            var psJerseySide = $('select[name="properties[PS Jersey Side]"]').val();
            if (psJerseySide) properties['PS Jersey Side'] = psJerseySide;
            var psLogoPosition = $('select[name="properties[PS Logo Position]"]').val();
            if (psLogoPosition) properties['PS Logo Position'] = psLogoPosition;
            var psLogoColorShape = $('select[name="properties[PS Logo Color Shape]"]').val();
            if (psLogoColorShape) properties['PS Logo Color Shape'] = psLogoColorShape;
          }

          console.log(properties);

          console.log(
            'Bag:', bagSmallNumberEnable,
            'Short', shortFrontNumberEnable,
            'Pant:', pantSmallNumberEnable,
            'Top:', topSmallNumberEnable,
            'Jacket:', jacketSmallNumberEnable,
            'Hoodie:', hoodieSmallNumberEnable,
            'Size', size
          );

          if ([
            frontNumberEnable,
            backNumberEnable,
            lastNameEnable,
            shortFrontNumberEnable,
            pantSmallNumberEnable,
            topSmallNumberEnable,
            topLastNameEnable,
            hoodieSmallNumberEnable,
            hoodieLastNameEnable,
            jacketSmallNumberEnable,
            jacketLastNameEnable,
            bagNameEnable,
            bagSmallNumberEnable
          ].some(f => f?.toLowerCase() === "yes")) {
            // start seperate logic 
            
            console.log("✅✅✅ [CUSTOM INFO] Starting Custom Info collection!");
            console.log("✅ [CUSTOM INFO] frontNumberEnable:", frontNumberEnable);
            console.log("✅ [CUSTOM INFO] backNumberEnable:", backNumberEnable);
            console.log("✅ [CUSTOM INFO] lastNameEnable:", lastNameEnable);

            console.log('DEBUG: size variable:', size);

            // Determine if this is Adult or Youth by checking parent container
            var isAdult = $(this).closest('.adult').length > 0;
            var isYouth = $(this).closest('.youth').length > 0;
            var prefix = isAdult ? 'Adult_' : (isYouth ? 'Youth_' : '');

            console.log('DEBUG: prefix:', prefix, 'isAdult:', isAdult, 'isYouth:', isYouth);

            // Build the full size tag with prefix (e.g., "Adult_X-Small" or "Youth_Small")
            var fullSizeTag = prefix + size;
            console.log('DEBUG: fullSizeTag for selector:', fullSizeTag);

            // Use attribute selector to find inputs with names containing the size tag
            // Filter for :visible to only get inputs that are shown (must be visible at time of Add to Cart click)
            var numbers = $('input[name*="number-' + fullSizeTag + '"]:visible');
            var names = $('input[name*="name-' + fullSizeTag + '"]:visible');

            console.log('DEBUG: Found', numbers.length, 'number inputs and', names.length, 'name inputs for size:', fullSizeTag);
            console.log('DEBUG: Selector used: input[name*="number-' + fullSizeTag + '"]:visible');

            // Log actual input values
            if (numbers.length > 0) {
              numbers.each(function (i, el) {
                console.log('  Number input', i, ':', el.name, '=', el.value);
              });
            } else {
              console.log('  ⚠️ No number inputs found! Selector: input[name*="number-' + fullSizeTag + '"]');
            }

            if (names.length > 0) {
              names.each(function (i, el) {
                console.log('  Name input', i, ':', el.name, '=', el.value);
              });
            } else {
              console.log('  ⚠️ No name inputs found! Selector: input[name*="name-' + fullSizeTag + '"]');
            }

            console.log(numbers.length, names.length);

            var numberValues = [];
            var nameValues = [];
            var customInfo = [];

            // Loop 1: Handle numbers
            for (var i = 0; i < numbers.length; i++) {
              var current_number = numbers.eq(i).val() || '';
              var numberValue = '';

              if (current_number !== '') {
                if (shortFrontNumberEnable === "yes") {
                  count_of_short_front_number++;
                  line_count_of_short_front_number++;
                }
                if (bagSmallNumberEnable === "yes") {
                  count_of_bag_number++;
                  line_count_of_bag_number++;
                }
                if (topSmallNumberEnable === "yes") {
                  count_of_top_number++;
                  line_count_of_top_number++;
                }
                if (pantSmallNumberEnable === "yes") {
                  count_of_pant_number++;
                  line_count_of_pant_number++;
                }
                if (hoodieSmallNumberEnable === "yes") {
                  count_of_hoodie_number++;
                  line_count_of_hoodie_number++;
                }
                if (jacketSmallNumberEnable === "yes") {
                  console.log("jacketSmallNumberEnable", jacketSmallNumberEnable);
                  count_of_jacket_number++;
                  line_count_of_jacket_number++;
                }
                if (backNumberEnable === "yes") {
                  count_of_back_number++;
                  line_count_of_back_number++;
                }
                if (frontNumberEnable === "yes") {
                  count_of_front_number++;
                  line_count_of_front_number++;
                }

                numberValue = current_number;
              }

              numberValues.push(numberValue);
            }

            // Loop 2: Handle names

            for (var i = 0; i < names.length; i++) {
              var current_name = names.eq(i).val() || '';
              var nameValue = '';

              if (current_name !== '') {
                if (lastNameEnable === "yes") {
                  count_of_custom_name++;
                  line_count_of_custom_name++;
                }
                if (jacketLastNameEnable === "yes") {
                  count_of_jacket_name++;
                  line_count_of_jacket_name++;
                }
                if (topLastNameEnable === "yes") {
                  count_of_top_name++;
                  line_count_of_top_name++;
                }
                if (bagNameEnable === "yes") {
                  count_of_bag_name++;
                  line_count_of_bag_name++;
                }
                if (hoodieLastNameEnable === "yes") {
                  count_of_hoodie_name++;
                  line_count_of_hoodie_name++;
                }

                nameValue = current_name;
              }

              nameValues.push(nameValue);
            }



            // Merge results into customInfo
            console.log('DEBUG: numberValues:', numberValues);
            console.log('DEBUG: nameValues:', nameValues);

            for (var i = 0; i < Math.max(numberValues.length, nameValues.length); i++) {
              var num = numberValues[i] || '';
              var name = nameValues[i] || '';
              console.log('DEBUG: Processing index', i, '- num:', num, 'name:', name);
              if (num === '' && name === '') { continue; }
              customInfo.push('(' + num + ', ' + name + ')');
            }

            console.log('DEBUG: Final customInfo array:', customInfo);

            // Assign to properties - convert array to comma-separated string (NOT newline)
            // Format: (0, a),(1, b),(2, c) - this matches Shopify's cart update behavior
            if (customInfo.length > 0) {
              properties['Custom Info'] = customInfo.join(',');
              console.log('✅✅✅ [CUSTOM INFO SET] Custom Info property added to properties object!');
              console.log('DEBUG: ✅ Custom Info SET:', properties['Custom Info']);
            } else {
              console.log('❌❌❌ [CUSTOM INFO EMPTY] No custom info collected - customInfo array is empty');
              console.log('DEBUG: ⚠️ Custom Info EMPTY - not setting property');
              // Don't set empty Custom Info - let Shopify handle it
            }

            console.log("manage yes", line_count_of_jacket_number);


            //end seperate logic
            if (line_count_of_front_number > 0) {
              properties['Count Front Numbers'] = line_count_of_front_number;
            }
            if (line_count_of_back_number > 0) {
              properties['Count Back Numbers'] = line_count_of_back_number;
            }
            if (line_count_of_custom_name > 0) {
              properties['Count Custom Names'] = line_count_of_custom_name;
            }
            if (line_count_of_custom_name > 0) {
              properties['Count Custom Names'] = line_count_of_custom_name;
            }
            if (line_count_of_bag_number > 0) {
              properties['Total Bag Numbers'] = line_count_of_bag_number;
            }
            if (line_count_of_top_number > 0) {
              properties['Total Top Numbers'] = line_count_of_top_number;
            }
            if (line_count_of_pant_number > 0) {
              properties['Total Pant Numbers'] = line_count_of_pant_number;
            }
            if (line_count_of_hoodie_number > 0) {
              properties['Total Hoodie Numbers'] = line_count_of_hoodie_number;
            }
            if (line_count_of_jacket_number > 0) {
              properties['Total Jacket Numbers'] = line_count_of_jacket_number;
            }

            if (line_count_of_short_front_number > 0) {
              properties['Total Short Numbers'] = line_count_of_short_front_number;
            }

            if (line_count_of_top_name > 0) {
              properties['Total Top Names'] = line_count_of_top_name;
            }
            if (line_count_of_hoodie_name > 0) {
              properties['Total Hoodie Names'] = line_count_of_hoodie_name;
            }
            if (line_count_of_jacket_name > 0) {
              properties['Total Jacket Names'] = line_count_of_jacket_name;
            }
            if (line_count_of_bag_name > 0) {
              properties['Total Bag Names'] = line_count_of_bag_name;
            }

          }


          if (apply_vector_fee == true
            || count_of_crest_logo
            || count_of_chest_logo

            || count_of_jacket_crest_logos
            || count_of_pant_crest_logos
            || count_of_bag_crest_logos
            || count_of_top_crest_logos
            || count_of_top_chest_logos


            || count_of_front_number
            || count_of_back_number
            || count_of_custom_name
            || count_of_pant_number
            || count_of_top_number

            || count_of_hoodie_number
            || count_of_jacket_number
            || count_of_hoodie_crest_logos
            || count_of_hoodie_chest_logos
            || count_of_bag_number

            || count_of_cap_crest_logos

            || count_of_jacket_name
            || count_of_hoodie_name
            || count_of_top_name
            || count_of_bag_name

            || count_of_short_front_number
            || count_of_jersey_sleeve_logo
            || count_of_jersey_sponsor_logo
            || count_of_jersey_team_name

          ) {

            properties['Item Status'] = "customized";
            console.log("✅ [ITEM STATUS] Set to 'customized'");
            console.log("✅ [PROPERTIES] Final properties object:", properties);

            if (total_bag_heat_press_crest_logos > 0) {
              properties['total_bag_heat_press_crest_logos'] = total_bag_heat_press_crest_logos;

            }
            if (total_bag_embroidery_crest_logos > 0) {
              properties['total_bag_embroidery_crest_logos'] = total_bag_embroidery_crest_logos;
            }


            if (total_jacket_heat_press_crest_logos > 0) {
              properties['total_jacket_heat_press_crest_logos'] = total_jacket_heat_press_crest_logos;
            }
            if (total_jacket_embroidery_crest_logos > 0) {
              properties['total_jacket_embroidery_crest_logos'] = total_jacket_embroidery_crest_logos;
            }

            if (total_pant_heat_press_crest_logos > 0) {
              properties['total_pant_heat_press_crest_logos'] = total_pant_heat_press_crest_logos;
            }
            if (total_pant_embroidery_crest_logos > 0) {
              properties['total_pant_embroidery_crest_logos'] = total_pant_embroidery_crest_logos;
            }

            if (total_top_heat_press_crest_logos > 0) {
              properties['total_top_heat_press_crest_logos'] = total_top_heat_press_crest_logos;
            }
            if (total_top_embroidery_crest_logos > 0) {
              properties['total_top_embroidery_crest_logos'] = total_top_embroidery_crest_logos;
            }

            if (total_top_heat_press_chest_logos > 0) {
              properties['total_top_heat_press_chest_logos'] = total_top_heat_press_chest_logos;
            }
            if (total_top_embroidery_chest_logos > 0) {
              properties['total_top_embroidery_chest_logos'] = total_top_embroidery_chest_logos;
            }

            if (total_hoodie_heat_press_crest_logos > 0) {
              properties['total_hoodie_heat_press_crest_logos'] = total_hoodie_heat_press_crest_logos;
            }
            if (total_hoodie_embroidery_crest_logos > 0) {
              properties['total_hoodie_embroidery_crest_logos'] = total_hoodie_embroidery_crest_logos;
            }

            if (total_hoodie_heat_press_chest_logos > 0) {
              properties['total_hoodie_heat_press_chest_logos'] = total_hoodie_heat_press_chest_logos;
            }
            if (total_hoodie_embroidery_chest_logos > 0) {
              properties['total_hoodie_embroidery_chest_logos'] = total_hoodie_embroidery_chest_logos;
            }

            if (total_cap_embroidery_crest_logos > 0) {
              properties['total_cap_embroidery_crest_logos'] = total_cap_embroidery_crest_logos;
            }

          }
          productItem.properties = properties;
          console.log('ProductItem being added:', {
            variantId: productItem.variantId,
            quantity: productItem.quantity,
            properties: productItem.properties,
            hasCustomInfo: !!productItem.properties['Custom Info'],
            customInfoValue: productItem.properties['Custom Info'],
            hasSize: properties[window.ProSoccerConfig.flags.socksSizeTagFound ? 'Sock Size' : 'Size']
          });
          productDetails.push(productItem);
          console.log("✅ [PRODUCT DETAILS] Added item to productDetails array");
          console.log("✅ [PRODUCT DETAILS] productDetails length:", productDetails.length);
          console.log("✅ [PRODUCT DETAILS] Item:", productItem);
        }
        else {
          console.log("❌ [NO CUSTOMIZATION] Customization checkbox not checked or disabled - adding to cartItems only");
          var item = { 'variantId': variantId, 'quantity': quantity, 'properties': properties };
          cartItems.push(item);
          console.log("✅ [CART ITEMS] Added to cartItems:", item);
        }
      }
    });
    
    console.log("🔵 [FINAL COUNTS] cartItems.length:", cartItems.length);
    console.log("🔵 [FINAL COUNTS] productDetails.length:", productDetails.length);
    console.log("🔵 [FINAL ARRAYS] cartItems:", cartItems);
    console.log("🔵 [FINAL ARRAYS] productDetails:", productDetails);
    
    // CART SUBMISSION RE-ENABLED
    console.log("✅✅✅ CART SUBMISSION IS NOW ENABLED ✅✅✅");

    if (apply_vector_fee == true) {
      var globalProductId = window.ProSoccerConfig.product.id;
      var alreadyVectorItem = $("#alreadyVectorItem").val();
      var uniqueVectorKeys = new Set(vectorLogoKeys.filter(Boolean));
      var uniqueKeyCount = uniqueVectorKeys.size;
      vectorQuantities = uniqueKeyCount > 1 ? 2 : 1;
      if (alreadyVectorItem === "no") {
        var item = {
          'variantId': 47913271656750,
          'quantity': vectorQuantities,
          "properties": { "productId": globalProductId }
        };
        cartItems.push(item);
      } else {
        // Replace (not accumulate) — processing fee is always 1 or 2
        // based on whether all logos across the entire cart are the same file.
        CartUpdateItems.push({
          "id": 47913271656750,
          "quantity": vectorQuantities,
          "properties": { "productId": globalProductId }
        });
      }
    }

    // start apply logo
    var globalProductId = window.ProSoccerConfig.product.id;

    // Generic handler for logo items (with Heat Press / Embroidery logic)
    function handleLogoItem(count, inputName, prevSelector, prevHeatId, prevEmbroideryId) {
      if (!count) return;

      let $el = $(`input[name="properties[${inputName}]"]:checked`),
        variantId = +$el.val(),
        currentType = $el.data('name')?.trim(),
        prevType = $(prevSelector).val()?.trim();

      if (!prevType) {
        cartItems.push({
          variantId,
          quantity: count,
          properties: { productId: globalProductId }
        });
      } else {
        let prevQty = +(
          currentType === 'Heat Press' && prevType === 'Heat Press'
            ? $(prevHeatId).val()
            : $(prevEmbroideryId).val()
        ) || 0;

        count += prevQty;

        CartUpdateItems.push({
          id: variantId,
          quantity: count,
          properties: { productId: globalProductId }
        });
      }
    }

    // Generic handler for simple items (no Heat Press/Embroidery logic)
    function handleSimpleItem(count, variantId, alreadySelector, alreadyTotalSelector) {
      if (!count) return;

      var alreadyItem = $(alreadySelector).val();
      if (alreadyItem === "no") {
        cartItems.push({
          variantId,
          quantity: count,
          properties: { productId: globalProductId }
        });
      } else {
        var existingTotal = parseInt($(alreadyTotalSelector).val()) || 0;
        CartUpdateItems.push({
          id: variantId,
          quantity: count + existingTotal,
          properties: { productId: globalProductId }
        });
      }
    }

    // ----- Logo Items -----
    handleLogoItem(count_of_bag_crest_logos, "bagCrestLogoType", "#prev_bag_logo_type", "#prev_total_bag_heat_press_crest_logos", "#prev_total_bag_embroidery_crest_logos");
    handleLogoItem(count_of_pant_crest_logos, "pantCrestLogoType", "#prev_pant_logo_type", "#prev_total_pant_heat_press_crest_logos", "#prev_total_pant_embroidery_crest_logos");
    handleLogoItem(count_of_jacket_crest_logos, "JacketCrestLogoType", "#prev_jacket_logo_type", "#prev_total_jacket_heat_press_crest_logos", "#prev_total_jacket_embroidery_crest_logos");
    handleLogoItem(count_of_top_crest_logos, "TopCrestLogoType", "#prev_top_crest_logo_type", "#prev_total_top_heat_press_crest_logos", "#prev_total_top_embroidery_crest_logos");
    handleLogoItem(count_of_top_chest_logos, "TopChestLogoType", "#prev_top_chest_logo_type", "#prev_total_top_heat_press_chest_logos", "#prev_total_top_embroidery_chest_logos");
    handleLogoItem(count_of_hoodie_crest_logos, "HoodieCrestLogoType", "#prev_hoodie_crest_logo_type", "#prev_total_hoodie_heat_press_crest_logos", "#prev_total_hoodie_embroidery_crest_logos");
    handleLogoItem(count_of_hoodie_chest_logos, "HoodieChestLogoType", "#prev_hoodie_chest_logo_type", "#prev_total_hoodie_heat_press_chest_logos", "#prev_total_hoodie_embroidery_chest_logos");

    handleLogoItem(count_of_cap_crest_logos, "CapCrestLogoType", "#prev_cap_crest_logo_type", null, "#prev_total_cap_embroidery_crest_logos");


    // ----- Simple Items -----
    // Crest: for Polos use the selected variant ID directly; for all others use the legacy fee variant
    if (count_of_crest_logo) {
      var crestSelectedVal = $('input[name="properties[showCrestLogoDropzone]"]:checked').val();
      var isPoloCrest = (crestSelectedVal !== 'yes' && crestSelectedVal !== 'no');
      if (isPoloCrest) {
        handleSimpleItem(count_of_crest_logo, +crestSelectedVal, "#alreadyCrestItem", "#alreadyCrestItemTotal");
      } else {
        handleSimpleItem(count_of_crest_logo, 47913297477934, "#alreadyCrestItem", "#alreadyCrestItemTotal");
      }
    }
    handleSimpleItem(count_of_chest_logo, 47913309274414, "#alreadyChestItem", "#alreadyChestItemTotal");
    handleSimpleItem(count_of_front_number, 47913304129838, "#alreadyFrontNumber", "#alreadyFrontNumberTotal");
    handleSimpleItem(count_of_jersey_sleeve_logo, 51936281428270, "#alreadyJerseySleeveLogoItem", "#alreadyJerseySleeveLogoTotal");
    handleSimpleItem(count_of_jersey_sponsor_logo, 51936282247470, "#alreadyJerseySponsorLogoItem", "#alreadyJerseySponsorLogoTotal");
    handleSimpleItem(count_of_jersey_team_name, 52243868385582, "#alreadyJerseyTeamNameItem", "#alreadyJerseyTeamNameTotal");


    function handleNameNumber(count, options) {
      if (!count) return;

      const { inputName, prevSelector, staticId } = options;

      // Determine variant ID: dynamic from input or static fallback
      let variantId = inputName ? $(`input[name="properties[${inputName}]"]:checked`).val() : staticId;

      console.log("variantId", variantId, "inputName", inputName);

      if (!variantId) return;

      // Previous total (0 if undefined)
      let prevTotal = parseInt($(prevSelector).val()) || 0;

      if (prevTotal < 1) {
        cartItems.push({
          variantId,
          quantity: count,
          properties: { productId: globalProductId }
        });
      } else {
        CartUpdateItems.push({
          id: variantId,
          quantity: count + prevTotal,
          properties: { productId: globalProductId }
        });
      }
    }

    handleNameNumber(count_of_short_front_number, { inputName: "shortFrontNumber", prevSelector: "#alreadyTotalShortNumber" });

    // Numbers (dynamic inputs)
    handleNameNumber(count_of_pant_number, { inputName: "pantSmallNumber", prevSelector: "#alreadyTotalPantNumber" });
    handleNameNumber(count_of_top_number, { inputName: "topSmallNumber", prevSelector: "#alreadyTotalTopNumber" });
    handleNameNumber(count_of_hoodie_number, { inputName: "hoodieSmallNumber", prevSelector: "#alreadyTotalHoodieNumber" });
    handleNameNumber(count_of_jacket_number, { inputName: "jacketSmallNumber", prevSelector: "#alreadyTotalJacketNumber" });
    handleNameNumber(count_of_bag_number, { inputName: "bagSmallNumber", prevSelector: "#alreadyTotalBagNumber" });

    // Names (static IDs or dynamic if input)
    handleNameNumber(count_of_top_name, { prevSelector: "#alreadyTotalTopName", staticId: 50485580890414 });
    handleNameNumber(count_of_hoodie_name, { prevSelector: "#alreadyTotalHoodieName", staticId: 50534311428398 });
    handleNameNumber(count_of_jacket_name, { prevSelector: "#alreadyTotalJacketName", staticId: 50536571699502 });
    handleNameNumber(count_of_bag_name, { inputName: "bagName", prevSelector: "#alreadyTotalbagName" });
    handleNameNumber(count_of_back_number, { prevSelector: "#alreadyBackNumber", staticId: 47913306521902 });
    handleNameNumber(count_of_custom_name, { prevSelector: "#alreadyCustomName", staticId: 47913308094766 });

    console.log("cartItems", cartItems, "CartUpdateItems", CartUpdateItems);
    //return false;

    // Validate that at least one size is selected
    if (cartItems.length === 0 && productDetails.length === 0) {
      alert('Please select at least one size and quantity');
      $('.product-form__submit').removeClass('loading');
      $('.product-form__submit').prop('disabled', false);
      return false;
    }

    if (CartUpdateItems.length > 0) {
      console.log("ready for update items");
      var formData = new FormData();
      $.each(CartUpdateItems, function (key, item) {
        formData.append("updates[" + item.id + "]", item.quantity);
      });

      setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
          .then(response => response.json())
          .then(data => {
            console.log("final cart", data);
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          });
      }, 6000); // 6 seconds delay
    }

    setTimeout(() => {
      if ($('#show_custom_info').prop('checked') && ($('#show_custom_info').prop('disabled') == false)) {
        function addItemsToCartSequentially(index) {
          if (index >= cartItems.length) {
            console.log('All cartItems added to cart successfully');
            // Define a function to perform the next Ajax request
            var performNextRequest = function (index) {
              if (index >= productDetails.length) {
                localStorage.setItem('triggerAction', 'true');
                window.location.href = '/cart';
                return;
              }

              var productItem = productDetails[index];
              var formData = new FormData();
              formData.append('id', productItem.variantId);
              formData.append('quantity', productItem.quantity);
              // Append the properties to the FormData object
              console.log('DEBUG: Building FormData with properties:', productItem.properties);
              
              // ========================================================================================
              // DEBUG: Check productItem files before FormData append
              // ========================================================================================
              console.log('🔍 [FORMDATA DEBUG] productItem files at submission time:', {
                crestLogoFile: productItem.crestLogoFile?.name || 'null',
                chestLogoFile: productItem.chestLogoFile?.name || 'null',
                sleeveLogoFile: productItem.sleeveLogoFile?.name || 'null',
                sponsorLogoFile: productItem.sponsorLogoFile?.name || 'null',
                productItem_keys: Object.keys(productItem)
              });
              
              for (var key in productItem.properties) {
                console.log('  FormData append:', key, '=', productItem.properties[key]);
                formData.append('properties[' + key + ']', productItem.properties[key]);
              }

              if (productItem.crestLogoFile) {
                console.log('✅ [FORMDATA] Adding crestLogoFile:', productItem.crestLogoFile.name);
                formData.append('properties[CrestLogoFile]', productItem.crestLogoFile);
                formData.append('properties[Crest Logo Name]', productItem.crestLogoFile.name);
              } else {
                console.log('❌ [FORMDATA] No crestLogoFile found in productItem');
              }
              
              if (productItem.chestLogoFile) {
                console.log('✅ [FORMDATA] Adding chestLogoFile:', productItem.chestLogoFile.name);
                formData.append('properties[ChestLogoFile]', productItem.chestLogoFile);
                formData.append('properties[Chest Logo Name]', productItem.chestLogoFile.name);
              } else {
                console.log('❌ [FORMDATA] No chestLogoFile found in productItem');
              }
              if (productItem.properties['Sleeve Logo'] === 'yes' && productItem.sleeveLogoFile) {
                formData.append('properties[SleeveLogoFile]', productItem.sleeveLogoFile);
              }
              if (productItem.sponsorLogoFile) {
                formData.append('properties[SponsorLogoFile]', productItem.sponsorLogoFile);
                formData.append('properties[Sponsor Logo Name]', productItem.sponsorLogoFile.name);
              }
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                  console.log('Successfully added product:', response);
                  performNextRequest(index + 1);
                },
                error: function (xhr, status, error) {
                  console.error('Error adding product to cart:', {
                    status: xhr.status,
                    statusText: xhr.statusText,
                    responseText: xhr.responseText,
                    error: error
                  });
                  alert('Error adding item to cart: ' + (xhr.responseJSON?.description || xhr.responseText || error));
                  performNextRequest(index + 1);
                }
              });
            };
            performNextRequest(0);
            return;
          }
          var item = cartItems[index];
          addToCart(item.variantId, item.properties, item.quantity, function (error, response) {
            if (error) {
              console.error('Error adding item to cart:', error);
              // Handle the error condition
            } else {
              console.log('Item added to cart:', response);
              // Move to the next item
              addItemsToCartSequentially(index + 1);
            }
          });
        }
        addItemsToCartSequentially(0);
      }
      else {
        function addItemsToCartSequentially(index) {
          if (index >= cartItems.length) {
            console.log('All items added to cart successfully');
            localStorage.setItem('triggerAction', 'true');
            location.replace(location.href);
            return;
          }

          var item = cartItems[index];
          addToCart(item.variantId, item.properties, item.quantity, function (error, response) {
            if (error) {
              console.error('Error adding item to cart:', error);
              // Handle the error condition
            } else {
              console.log('Item added to cart:', response);
              // Move to the next item
              addItemsToCartSequentially(index + 1);
            }
          });
        }
        addItemsToCartSequentially(0);
      }
    }, 8000);
    
  });
}); // Close the main handler

/* ========== Script Block 7 ========== */
$(document).on("keydown", ".player_name", function (event) {
  if (event.key >= 0 && event.key <= 9) {
    event.preventDefault();
  }
});
// Wait for the page to reload, then trigger a click event
$(document).ready(function () {
  var triggerAction = localStorage.getItem('triggerAction');
  console.log(triggerAction);
  if (triggerAction === 'true') {
    const openMiniCartElement = document.querySelector('.open-minicart');
    openMiniCartElement.onClickMiniCart(); // Call the onClickMiniCart method
    localStorage.removeItem('triggerAction');
  }
});

/* ========== Script Block 8 ========== */
$(document).ready(function () {
  console.log("code for line 2762")
  var checkout_btn = $('.product-form__submit');
  var product_vendor = window.ProSoccerConfig.product.vendor;
  var socks = window.ProSoccerConfig.flags.isSocks;
  var productTags = window.ProSoccerConfig.product.tags;
  var bags = window.ProSoccerConfig.flags.isBags;
  var isVest = productTags.some(tag => tag.toLowerCase().includes('vest'));

  var info_box = $('#show_custom_info');
  checkout_btn.prop('disabled', true);

  var minOrder = 1;

  if (socks == "true" && product_vendor == "Joma") {
    minOrder = 4;
  }
  if (product_vendor == 'Umbro') {
    minOrder = 7;
  }
  if (isVest) {
    minOrder = 12;
  }

  //update cart button

  function updateButtonState() {
    var inputs = $('.product-form__quantity .quantity__input');
    var sum = inputs.toArray().reduce((acc, el) => acc + (Number(el.value) || 0), 0);
    var isCustomized = $('#show_custom_info').is(':checked');

    // Select scrimmage vests: always enforce multiples of 12, customized or not
    if (product_vendor === "Select" && window.ProSoccerConfig.product.type === "Scrimmage Vest") {
      var allValid = inputs.toArray().every(el => {
        var val = Number(el.value) || 0;
        return val === 0 || val % 12 === 0;
      });
      checkout_btn.prop('disabled', !allValid || sum === 0);
    }
    else if (isVest && isCustomized) {
      var allValid = inputs.toArray().every(el => {
        var val = Number(el.value) || 0;
        return val === 0 || val % 12 === 0;
      });
      checkout_btn.prop('disabled', !allValid);
    }
    else if (socks === "true" && product_vendor === "Joma") {
      // Joma socks must always be multiples of 4, customized or not
      checkout_btn.prop('disabled', sum === 0 || sum % 4 !== 0);
    }
    else if (isCustomized) {
      checkout_btn.prop('disabled', sum < minOrder);
    }
    else {
      checkout_btn.prop('disabled', sum < 1);
    }

    // 🔴 Prevent override for vest
    if (!isVest && $('#show_custom_info').hasClass('already') && product_vendor !== "Joma") {
      checkout_btn.removeAttr('disabled');
    }
  }

  // $(document).on('change', '.product-form__quantity .quantity__input', updateButtonState); // REMOVED - Handled by unified handler
  $('select[name="options[Color]"]').on('change', function () {
    showLoader();
    setTimeout(function () {
      updateButtonState();
      hideLoader();
    }, 2000);
  });
});

/* ========== Script Block 9 ========== */
function handleOnlyTwoCharacters(event) {
  var keyPressed = event.key;
  var inputField = event.target;
  var currentLength = inputField.value.length;
  if (!/[0-9]/.test(keyPressed) || currentLength >= 2) {
    event.preventDefault();
  }
}

/* ========== Script Block 10 ========== */
$(document).ready(function () {
  let customizable = window.ProSoccerConfig.flags.customizable;
  let bags = window.ProSoccerConfig.flags.isBags;

  const svgIcon = ``;

    const productType = window.ProSoccerConfig?.product?.type || '';
  const vendor = window.ProSoccerConfig?.product?.vendor || '';

  let noteText = `We recommend emailing us at <a style="color:#8a5c07; font-weight:600;" href="mailto:team@prosoccer.com">team@prosoccer.com</a> to check availability before ordering.`;

  if (customizable) {
    if (bags) {
      noteText += `<br><strong>Note</strong>: After checkout, we'll reach out to finalize your team's logo position. Want a mockup? Just email us after placing your order.`;
    } else {
      noteText += `<br><strong>Note</strong>: Want a mockup? Just email us after placing your order.`;
    }
  }

  if (productType && vendor !== 'Select') {
    noteText += `<br>Qty based on the total # of items in your cart that belong to the "${productType}" collection.`;
  }

  $(".psc-cart-bar").after(`<div class="fee-note">${svgIcon}<span>${noteText}</span></div>`);
});

/* ========== Script Block 11 ========== */
document.addEventListener('DOMContentLoaded', function () {
  function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');

    return (msie > 0 || trident > 0);
  }

  if (!isIE()) return;
  const hiddenInput = document.querySelector('#' + window.ProSoccerConfig.product.formId + ' input[name="id"]');
  const noScriptInputWrapper = document.createElement('div');
  const variantSwitcher = document.querySelector('variant-radios[data-section="' + window.ProSoccerConfig.section.id + '"]') || document.querySelector('variant-selects[data-section="' + window.ProSoccerConfig.section.id + '"]');
  noScriptInputWrapper.innerHTML = document.querySelector('.product-form__noscript-wrapper-' + window.ProSoccerConfig.section.id).textContent;
  variantSwitcher.outerHTML = noScriptInputWrapper.outerHTML;

  document.querySelector('#Variants-' + window.ProSoccerConfig.section.id).addEventListener('change', function (event) {
    hiddenInput.value = event.currentTarget.value;
  });
});

// ========================================================================================
// FILE CAPTURE EVENT LISTENERS - Capture files immediately when uploaded
// This ensures we never lose track of uploaded files regardless of DOM changes
// ========================================================================================

$(document).ready(function() {
  // Capture jersey crest logo files
  $(document).on('change', '#crest_logo', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#crest_logo_2', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  // Capture jersey chest logo files  
  $(document).on('change', '#chest_logo', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('chestLogoFile', this.files[0]);
    }
  });
  
  // Capture individual product logo files
  $(document).on('change', '#hoodie_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#hoodie_chest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('chestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#top_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#top_chest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('chestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#jacket_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#cap_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#bag_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#pant_crest_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('crestLogoFile', this.files[0]);
    }
  });
  
  // Capture other logo types
  $(document).on('change', '#sleeve_logo_file, #top_sleeve_logo_file, #jacket_sleeve_logo_file, #hoodie_sleeve_logo_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('sleeveLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#sponsor_logo_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('sponsorLogoFile', this.files[0]);
    }
  });
  
  $(document).on('change', '#ps_logo_file', function() {
    if (this.files && this.files[0]) {
      storeUploadedFile('psLogoFile', this.files[0]);
    }
  });
  
  // ========================================================================================
  // PLAYER NAME INPUT DEBUG - Check for spacing issues
  // ========================================================================================
  
  // Debug player name inputs to see if spaces are being handled properly
  $(document).on('input', '.player_name, .roster-name, input[name*="name-"]', function() {
    console.log('🔤 [PLAYER NAME DEBUG] Input value:', '"' + this.value + '"');
    console.log('🔤 [PLAYER NAME DEBUG] Length:', this.value.length);
    console.log('🔤 [PLAYER NAME DEBUG] Has spaces:', this.value.includes(' '));
    
    // Check if spaces are being preserved
    if (this.value.includes(' ')) {
      console.log('✅ [PLAYER NAME DEBUG] Spaces are working correctly');
    } else if (this.value.length > 3) {
      console.log('⚠️ [PLAYER NAME DEBUG] No spaces detected in longer name');
    }
  });
  
  // Check for any keypress restrictions
  $(document).on('keypress', '.player_name, .roster-name, input[name*="name-"]', function(e) {
    var key = e.key;
    console.log('⌨️ [PLAYER NAME DEBUG] Key pressed:', '"' + key + '"');
    if (key === ' ') {
      console.log('🔤 [PLAYER NAME DEBUG] Space key detected');
    }
  });
  
  console.log('✅ [PLAYER NAME DEBUG] Debug listeners initialized');
  
  // ========================================================================================  
  // SPACE FIX - Override any handlers that might be blocking spaces in player names
  // This handler runs AFTER other handlers and allows spaces specifically
  // ========================================================================================
  
  $(document).on('keydown', '.player_name, .roster-name, input[name*="name-"]', function(e) {
    // Allow spaces explicitly - don't prevent default for space key
    if (e.key === ' ' || e.keyCode === 32) {
      console.log('🔧 [SPACE FIX] Space key detected - forcing it through');
      
      // STOP other handlers from running after this one
      e.stopImmediatePropagation();
      e.stopPropagation();
      
      // Manually insert the space into the input field
      var input = this;
      var currentValue = input.value;
      var cursorPosition = input.selectionStart;
      
      // Insert space at cursor position
      var newValue = currentValue.slice(0, cursorPosition) + ' ' + currentValue.slice(cursorPosition);
      input.value = newValue;
      
      // Move cursor after the inserted space
      input.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
      
      console.log('🔧 [SPACE FIX] Space manually inserted:', '"' + input.value + '"');
      
      // Trigger input event to update any watchers
      $(input).trigger('input');
      
      return false;
    }
    
    // Block numbers in name fields (this is what the original handler was supposed to do)
    if (e.key >= '0' && e.key <= '9') {
      console.log('🚫 [SPACE FIX] Number blocked in name field:', e.key);
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  });
  
  console.log('✅ [SPACE FIX] Space override handler installed');
  
  // ========================================================================================
  // REAL-TIME CALCULATION DISPLAY
  // Updates the calculation bar as users select customizations
  // ========================================================================================
  
  function updateCalculationDisplay() {
    const calcBar = $('#psc-calc-bar');
    const calcCount = $('#psc-bar-label');
    const calcFee = $('#psc-bar-fee');
    const calcPrice = $('#psc-bar-price');
    if (!calcBar.length || !calcPrice.length) return;
    
    let customizationCount = 0;
    let totalPrice = 0;
    let logoFeeApplies = false;
    let customizations = [];
    
    // Check jersey customizations
    const crestLogo = $('input[name="properties[showCrestLogoDropzone]"]:checked').val();
    const chestType = $('input[name="properties[showChestType]"]:checked').val();
    const frontNumber = $('input[name="properties[frontNumber]"]:checked').val();
    const backNumber = $('input[name="properties[backNumberSize]"]:checked').val();
    const lastName = $('input[name="properties[lastName]"]:checked').val();
    
    // Count jersey customizations
    if (crestLogo && crestLogo !== 'no') {
      customizationCount++;
      customizations.push('Crest Logo');
      logoFeeApplies = true;
      totalPrice += getSelectedOptionPrice('input[name="properties[showCrestLogoDropzone]"]:checked', 6);
    }
    
    if (chestType && chestType === 'yes') {
      customizationCount++;
      customizations.push('Chest Logo');
      logoFeeApplies = true;
      totalPrice += getSelectedOptionPrice('input[name="properties[showChestType]"]:checked', 10);
    }
    
    if (frontNumber && frontNumber === 'yes') {
      customizationCount++;
      customizations.push('Front Number');
      totalPrice += getSelectedOptionPrice('input[name="properties[frontNumber]"]:checked', 3.5);
    }
    
    if (backNumber && backNumber === 'yes') {
      customizationCount++;
      customizations.push('Back Number');
      totalPrice += getSelectedOptionPrice('input[name="properties[backNumberSize]"]:checked', 5);
    }
    
    if (lastName && lastName === 'yes') {
      customizationCount++;
      customizations.push('Player Name');
      totalPrice += getSelectedOptionPrice('input[name="properties[lastName]"]:checked', 7);
    }

    // Check jersey-only customizations
    const sleeveLogoSelected = $('input[name="properties[jerseySleeveLogoEnable]"]:checked, input[name="properties[topSleeveLogoEnable]"]:checked, input[name="properties[jacketSleeveLogoEnable]"]:checked, input[name="properties[hoodieSleeveLogoEnable]"]:checked')
      .filter(function() { return $(this).val() === 'yes'; }).length > 0;
    const jerseySponsorLogoEnable = $('input[name="properties[jerseySponsorLogoEnable]"]:checked').val();
    const jerseyTeamNameEnable = $('input[name="properties[jerseyTeamNameEnable]"]:checked').val();

    if (sleeveLogoSelected) {
      customizationCount++;
      customizations.push('Sleeve Logo');
      logoFeeApplies = true;
      totalPrice += 6;
    }

    if (jerseySponsorLogoEnable === 'yes') {
      customizationCount++;
      customizations.push('Sponsor/Team Logo');
      logoFeeApplies = true;
      totalPrice += 10;
    }

    if (jerseyTeamNameEnable === 'yes') {
      customizationCount++;
      customizations.push('Team Name');
      logoFeeApplies = true;
      totalPrice += 7;
    }
    
    // Check bag customizations with dynamic pricing and debugging
    const bagCrestLogo = $('input[name="properties[bagCrestLogoType]"]:checked').val();
    const bagSmallNumber = $('input[name="properties[bagSmallNumber]"]:checked').val();
    const bagName = $('input[name="properties[bagName]"]:checked').val();
    
    console.log('🔍 [BAG DEBUG] Current selections:', {
      bagCrestLogo: bagCrestLogo,
      bagSmallNumber: bagSmallNumber,
      bagName: bagName
    });
    
    if (bagCrestLogo && bagCrestLogo !== '0' && bagCrestLogo !== 'no') {
      customizationCount++;
      logoFeeApplies = true;
      const bagCrestType = $('input[name="properties[bagCrestLogoType]"]:checked').attr('data-name');
      console.log('🎒 [BAG CREST] Type:', bagCrestType);
      if (bagCrestType === 'Heat Press') {
        customizations.push('Bag Crest (Heat Press)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagCrestLogoType]"]:checked', 7);
      } else if (bagCrestType === 'Embroidery') {
        customizations.push('Bag Crest (Embroidery)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagCrestLogoType]"]:checked', 12);
      }
    }
    
    if (bagSmallNumber && bagSmallNumber !== 'no') {
      customizationCount++;
      const bagNumberType = $('input[name="properties[bagSmallNumber]"]:checked').attr('data-name');
      console.log('🔢 [BAG NUMBER] Value:', bagSmallNumber, 'Type:', bagNumberType);
      if (bagNumberType === 'Heat Press') {
        customizations.push('Bag Number (Heat Press)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagSmallNumber]"]:checked', 6);
      } else if (bagNumberType === 'Embroidery') {
        customizations.push('Bag Number (Embroidery)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagSmallNumber]"]:checked', 10);
      }
    }
    
    if (bagName && bagName !== 'no') {
      customizationCount++;
      const bagNameType = $('input[name="properties[bagName]"]:checked').attr('data-name');
      console.log('📝 [BAG NAME] Value:', bagName, 'Type:', bagNameType);
      if (bagNameType === 'Heat Press') {
        customizations.push('Bag Name (Heat Press)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagName]"]:checked', 9);
      } else if (bagNameType === 'Embroidery') {
        customizations.push('Bag Name (Embroidery)');
        totalPrice += getSelectedOptionPrice('input[name="properties[bagName]"]:checked', 12);
      }
    }
    
    // Check individual product customizations
    const productCustomizations = [
      { selector: 'input[name="properties[TopCrestLogoType]"]:checked', name: 'Top Crest', getPrice: function() { return getCurrentPrice('topCrest', 'TopCrestLogoType'); } },
      { selector: 'input[name="properties[TopChestLogoType]"]:checked', name: 'Top Chest', getPrice: function() { return getCurrentPrice('topChest', 'TopChestLogoType'); } },
      { selector: 'input[name="properties[topSmallNumber]"]:checked', name: 'Top Number', getPrice: function() { return getCurrentPrice('topNumber', 'topSmallNumber'); } },
      { selector: 'input[name="properties[TopLastName]"]:checked', name: 'Top Name', getPrice: function() { return getCurrentPrice('topName', 'TopLastName'); } },
      { selector: 'input[name="properties[HoodieCrestLogoType]"]:checked', name: 'Hoodie Crest', getPrice: function() { return getCurrentPrice('hoodieCrest', 'HoodieCrestLogoType'); } },
      { selector: 'input[name="properties[HoodieChestLogoType]"]:checked', name: 'Hoodie Chest', getPrice: function() { return getCurrentPrice('hoodieChest', 'HoodieChestLogoType'); } },
      { selector: 'input[name="properties[hoodieSmallNumber]"]:checked', name: 'Hoodie Number', getPrice: function() { return getCurrentPrice('hoodieNumber', 'hoodieSmallNumber'); } },
      { selector: 'input[name="properties[HoodieLastName]"]:checked', name: 'Hoodie Name', getPrice: function() { return getCurrentPrice('hoodieName', 'HoodieLastName'); } },
      { selector: 'input[name="properties[JacketCrestLogoType]"]:checked', name: 'Jacket Crest', getPrice: function() { return getCurrentPrice('jacketCrest', 'JacketCrestLogoType'); } },
      { selector: 'input[name="properties[jacketSmallNumber]"]:checked', name: 'Jacket Number', getPrice: function() { return getCurrentPrice('jacketNumber', 'jacketSmallNumber'); } },
      { selector: 'input[name="properties[jacketLastName]"]:checked', name: 'Jacket Name', getPrice: function() { return getCurrentPrice('jacketName', 'jacketLastName'); } },
      { selector: 'input[name="properties[CapCrestLogoType]"]:checked', name: 'Cap Crest', getPrice: function() { return getCurrentPrice('capCrest', 'CapCrestLogoType'); } },
      { selector: 'input[name="properties[PantCrestLogoType]"]:checked', name: 'Pant Crest', getPrice: function() { return getCurrentPrice('pantCrest', 'pantCrestLogoType'); } },
      { selector: 'input[name="properties[pantSmallNumber]"]:checked', name: 'Pant Number', getPrice: function() { return getCurrentPrice('pantNumber', 'pantSmallNumber'); } },
      { selector: 'input[name="properties[shortFrontNumber]"]:checked', name: 'Short Number', basePrice: 3.5 }
    ];
    
    productCustomizations.forEach(function(custom) {
      const value = $(custom.selector).val();
      if (value && value !== '0' && value !== 'no') {
        customizationCount++;
        customizations.push(custom.name);
        const fallbackPrice = typeof custom.getPrice === 'function' ? custom.getPrice() : custom.basePrice;
        totalPrice += getSelectedOptionPrice(custom.selector, fallbackPrice);
        if (custom.name.includes('Crest') || custom.name.includes('Chest')) {
          logoFeeApplies = true;
        }
      }
    });
    
    // Add logo processing fee if applicable
    if (logoFeeApplies) {
      totalPrice += 35;
    }
    
    // Get base product price
    const basePrice = Number(window.baseProductPrice);
    if (!Number.isFinite(basePrice)) {
      console.error('[CALCULATION DISPLAY] Base product price is unavailable.');
      return;
    }
    const finalPrice = basePrice + totalPrice;
    
    // Always show the calculation bar
    calcBar.show().attr('aria-live', 'polite');
    
    // Update display based on customizations
    if (customizationCount > 0) {
      // Customizations selected - show dark theme
      calcBar.removeClass('base-price');
      
      const countText = customizationCount === 1 
        ? '1 customization selected' 
        : `${customizationCount} customizations selected`;
      
      calcCount.text(countText);
      calcFee.text(logoFeeApplies ? 'incl. $35.00 logo fee' : '').toggle(logoFeeApplies);
      calcPrice.text(`$${finalPrice.toFixed(2)}`);
      
      console.log('💰 [CALC UPDATE - CUSTOMIZATIONS]', {
        customizations: customizations,
        count: customizationCount,
        customizationPrice: totalPrice,
        logoFee: logoFeeApplies,
        basePrice: basePrice,
        finalTotal: finalPrice,
        bagDetails: {
          crest: bagCrestLogo,
          number: bagSmallNumber,
          name: bagName
        }
      });
    } else {
      // No customizations - show base price with light theme
      calcBar.addClass('base-price');

      calcCount.text('No customizations yet');
      calcFee.hide();
      calcPrice.text(`$${basePrice.toFixed(2)}`);
    }
  }

  function getSelectedOptionPrice(selector, fallback) {
    const $selectedInput = $(selector).first();
    if (!$selectedInput.length) return fallback;

    const $price = $selectedInput.closest('.toggle-left-right-holder').find('.field-price').first();
    const priceMatch = $price.text().match(/\$([\d]+(?:\.[\d]+)?)/);
    return priceMatch ? Number(priceMatch[1]) : fallback;
  }

  function updateBaseProductPrice() {
    const variantPicker = document.querySelector('variant-selects, variant-radios');
    const variantPrice = variantPicker?.currentVariant?.price;
    if (Number.isFinite(Number(variantPrice))) {
      window.baseProductPrice = Number(variantPrice) / 100;
      updateCalculationDisplay();
    }
  }

  $(document).on('change', 'input[name="id"], select[name="id"]', function() {
    updateBaseProductPrice();
  });
  
  // Single unified event listener for calculation updates
  // ========== DYNAMIC PRICING SYSTEM ==========
  // Central function to get current pricing for any customization type
  function getDynamicPricing() {
    const pricing = {
      // Bag customizations
      bagCrest: { heatPress: 7, embroidery: 15 },
      bagNumber: { heatPress: 6, embroidery: 10 },
      bagName: { heatPress: 9, embroidery: 12 },
      
      // Hoodie customizations  
      hoodieCrest: { heatPress: 7, embroidery: 15 },
      hoodieChest: { heatPress: 10, embroidery: 15 },
      hoodieNumber: { heatPress: 6, embroidery: 10 },
      hoodieName: { heatPress: 8, embroidery: 12 },
      
      // Cap customizations
      capCrest: { heatPress: 12, embroidery: 15 },
      
      // Top customizations
      topCrest: { heatPress: 7, embroidery: 15 },
      topChest: { heatPress: 10, embroidery: 15 },
      topNumber: { heatPress: 6, embroidery: 10 },
      topName: { heatPress: 8, embroidery: 12 },
      
      // Jacket customizations
      jacketCrest: { heatPress: 7, embroidery: 15 },
      jacketNumber: { heatPress: 6, embroidery: 10 },
      jacketName: { heatPress: 8, embroidery: 12 },
      
      // Pant customizations
      pantCrest: { heatPress: 7, embroidery: 15 },
      pantNumber: { heatPress: 6, embroidery: 10 }
    };
    
    return pricing;
  }

  // Function to get current price for a specific customization
  function getCurrentPrice(customizationType, propertyName) {
    const pricing = getDynamicPricing();
    const selectedInput = $(`input[name="properties[${propertyName}]"]:checked`);
    const dataName = selectedInput.attr('data-name');
    
    console.log(`💰 [GET PRICE] Type: ${customizationType}, Property: ${propertyName}`);
    console.log(`💰 [GET PRICE] Selected input:`, selectedInput.length, selectedInput.val());
    console.log(`💰 [GET PRICE] Data-name:`, dataName);
    console.log(`💰 [GET PRICE] Pricing for type:`, pricing[customizationType]);
    
    if (!pricing[customizationType]) {
      console.warn(`⚠️ [PRICING] Unknown customization type: ${customizationType}`);
      return 0;
    }
    
    if (dataName === 'Heat Press') {
      console.log(`💰 [GET PRICE] Returning Heat Press price:`, pricing[customizationType].heatPress);
      return pricing[customizationType].heatPress;
    } else if (dataName === 'Embroidery') {
      console.log(`💰 [GET PRICE] Returning Embroidery price:`, pricing[customizationType].embroidery);
      return pricing[customizationType].embroidery;
    }
    
    console.log(`💰 [GET PRICE] No match for data-name "${dataName}", returning 0`);
    return 0; // No selection or unknown type
  }

  // Function to update ALL dynamic pricing displays across the page
  function updateAllDynamicPricing() {
    console.log('🔄 [DYNAMIC PRICING] Updating all pricing displays...');
    
    // Update bag pricing in roster rows
    updateBagRosterPricing();
    
    // Update hoodie pricing in roster rows
    updateHoodieRosterPricing();
    
    // Update jacket pricing in roster rows  
    updateJacketRosterPricing();
    
    // Update top pricing in roster rows
    updateTopRosterPricing();
    
    // Update pant pricing in roster rows
    updatePantRosterPricing();
    
    // Trigger main calculation update
    setTimeout(updateCalculationDisplay, 100);
  }

  // Specific function to update bag roster pricing
  function updateBagRosterPricing() {
    const bagNumberPrice = getCurrentPrice('bagNumber', 'bagSmallNumber');
    const bagNamePrice = getCurrentPrice('bagName', 'bagName');
    
    console.log('💰 [BAG PRICING] Number: $' + bagNumberPrice + ', Name: $' + bagNamePrice);
    
    // Only update roster prices INSIDE the bag-specific containers
    $('#bag_number_row .roster-price').each(function() {
      $(this).text(`$${bagNumberPrice.toFixed(2)}`);
    });
    
    $('#bag_name_row .roster-price').each(function() {
      $(this).text(`$${bagNamePrice.toFixed(2)}`);
    });
    
    // Also scope by roster-field structure within bag rows
    $('#bag_number_row .roster-field, #bag_name_row .roster-field').each(function() {
      const $priceSpan = $(this).find('.roster-price');
      if ($priceSpan.length > 0) {
        if ($(this).find('.player_number').length > 0) {
          $priceSpan.text(`$${bagNumberPrice.toFixed(2)}`);
        } else if ($(this).find('.player_name').length > 0) {
          $priceSpan.text(`$${bagNamePrice.toFixed(2)}`);
        }
      }
    });
    
    console.log('✅ [BAG PRICING] Updated bag roster displays');
  }

  // Function to update hoodie roster pricing
  function updateHoodieRosterPricing() {
    const hoodieNumberPrice = getCurrentPrice('hoodieNumber', 'hoodieSmallNumber');
    const hoodieNamePrice = getCurrentPrice('hoodieName', 'HoodieLastName');
    
    console.log('💰 [HOODIE PRICING] Number: $' + hoodieNumberPrice + ', Name: $' + hoodieNamePrice);
    
    // Only update roster prices INSIDE the hoodie-specific containers
    $('#hoodie_number_row .roster-price').each(function() {
      $(this).text(`$${hoodieNumberPrice.toFixed(2)}`);
    });
    
    $('#hoodie_name_row .roster-price').each(function() {
      $(this).text(`$${hoodieNamePrice.toFixed(2)}`);
    });
    
    // Scope by roster-field structure within hoodie rows
    $('#hoodie_number_row .roster-field, #hoodie_name_row .roster-field').each(function() {
      const $priceSpan = $(this).find('.roster-price');
      if ($priceSpan.length > 0) {
        if ($(this).find('.player_number').length > 0) {
          $priceSpan.text(`$${hoodieNumberPrice.toFixed(2)}`);
        } else if ($(this).find('.player_name').length > 0) {
          $priceSpan.text(`$${hoodieNamePrice.toFixed(2)}`);
        }
      }
    });
    
    console.log('✅ [HOODIE PRICING] Updated hoodie roster displays');
  }

  // Function to update jacket roster pricing
  function updateJacketRosterPricing() {
    const jacketNumberPrice = getCurrentPrice('jacketNumber', 'jacketSmallNumber');
    const jacketNamePrice = getCurrentPrice('jacketName', 'jacketLastName');
    
    console.log('💰 [JACKET PRICING] Number: $' + jacketNumberPrice + ', Name: $' + jacketNamePrice);
    
    // Only update roster prices INSIDE the jacket-specific containers
    $('#jacket_number_row .roster-price').each(function() {
      $(this).text(`$${jacketNumberPrice.toFixed(2)}`);
    });
    
    $('#jacket_name_row .roster-price').each(function() {
      $(this).text(`$${jacketNamePrice.toFixed(2)}`);
    });
    
    // Scope by roster-field structure within jacket rows
    $('#jacket_number_row .roster-field, #jacket_name_row .roster-field').each(function() {
      const $priceSpan = $(this).find('.roster-price');
      if ($priceSpan.length > 0) {
        if ($(this).find('.player_number').length > 0) {
          $priceSpan.text(`$${jacketNumberPrice.toFixed(2)}`);
        } else if ($(this).find('.player_name').length > 0) {
          $priceSpan.text(`$${jacketNamePrice.toFixed(2)}`);
        }
      }
    });
    
    console.log('✅ [JACKET PRICING] Updated jacket roster displays');
  }

  // Function to update top roster pricing
  function updateTopRosterPricing() {
    const topNumberPrice = getCurrentPrice('topNumber', 'topSmallNumber');
    const topNamePrice = getCurrentPrice('topName', 'TopLastName');
    
    console.log('💰 [TOP PRICING] Number: $' + topNumberPrice + ', Name: $' + topNamePrice);
    
    // Only update roster prices INSIDE the top-specific containers
    $('#top_number_row .roster-price').each(function() {
      $(this).text(`$${topNumberPrice.toFixed(2)}`);
    });
    
    $('#top_name_row .roster-price').each(function() {
      $(this).text(`$${topNamePrice.toFixed(2)}`);
    });
    
    // Scope by roster-field structure within top rows
    $('#top_number_row .roster-field, #top_name_row .roster-field').each(function() {
      const $priceSpan = $(this).find('.roster-price');
      if ($priceSpan.length > 0) {
        if ($(this).find('.player_number').length > 0) {
          $priceSpan.text(`$${topNumberPrice.toFixed(2)}`);
        } else if ($(this).find('.player_name').length > 0) {
          $priceSpan.text(`$${topNamePrice.toFixed(2)}`);
        }
      }
    });
    
    console.log('✅ [TOP PRICING] Updated top roster displays');
  }

  // Function to update pant roster pricing
  function updatePantRosterPricing() {
    const pantNumberPrice = getCurrentPrice('pantNumber', 'pantSmallNumber');
    
    $('.pant_small_number_holder .roster-price').text(`$${pantNumberPrice.toFixed(2)}`);
    
    console.log('👖 [PANT PRICING] Updated - Number: $' + pantNumberPrice);
  }

  // ========== CENTRALIZED EVENT LISTENERS FOR ALL CUSTOMIZATIONS ==========
  // This handles ALL customization changes in one place to avoid conflicts
  
  // Universal listener for ALL customization radio buttons
  $(document).on('change', 'input[type="radio"][name*="properties["]', function() {
    const inputName = $(this).attr('name');
    const inputValue = $(this).val();
    const dataName = $(this).attr('data-name');
    
    console.log('🎯 [CENTRALIZED] Radio changed:', inputName, '=', inputValue, 'Type:', dataName);
    
    // Update all dynamic pricing first
    setTimeout(updateAllDynamicPricing, 50);
    
    // Then update calculation
    setTimeout(updateCalculationDisplay, 150);
  });
  
  // Universal listener for ALL customization checkboxes
  $(document).on('change', 'input[type="checkbox"][name*="properties["]', function() {
    const inputName = $(this).attr('name');
    const inputValue = $(this).val();
    const isChecked = $(this).is(':checked');
    
    console.log('☑️ [CENTRALIZED] Checkbox changed:', inputName, '=', inputValue, 'Checked:', isChecked);
    
    // Update all dynamic pricing first
    setTimeout(updateAllDynamicPricing, 50);
    
    // Then update calculation
    setTimeout(updateCalculationDisplay, 150);
  });
  
  // Specific listeners for bag customizations (most important for current issue)
  $(document).on('change', 'input[name="properties[bagCrestLogoType]"], input[name="properties[bagSmallNumber]"], input[name="properties[bagName]"]', function() {
    const bagInput = $(this);
    console.log('🎒 [BAG SPECIFIC] Changed:', bagInput.attr('name'), '=', bagInput.val(), 'Type:', bagInput.attr('data-name'));
    
    // Multiple triggers to ensure it catches
    setTimeout(updateCalculationDisplay, 50);
    setTimeout(updateCalculationDisplay, 150);
    setTimeout(updateCalculationDisplay, 300);
  });

  // Specific listeners for jacket customizations
  $(document).on('change', 'input[name="properties[jacketSmallNumber]"], input[name="properties[jacketLastName]"], input[name="properties[JacketCrestLogoType]"]', function() {
    const jacketInput = $(this);
    console.log('🧥 [JACKET SPECIFIC] Changed:', jacketInput.attr('name'), '=', jacketInput.val(), 'Type:', jacketInput.attr('data-name'));
    
    // Call jacket-specific roster update if available
    if (typeof appendNames === 'function') {
      setTimeout(appendNames, 50);
      setTimeout(appendNames, 150);
      setTimeout(appendNames, 300); // Multiple attempts to ensure it catches
    }
    
    // Also update pricing and calculations
    setTimeout(updateCalculationDisplay, 100);
    setTimeout(updateAllDynamicPricing, 100);
  });

  // Add roster update triggers for other customization types
  $(document).on('change', 'input[name="properties[hoodieSmallNumber]"], input[name="properties[HoodieLastName]"], input[name="properties[HoodieCrestLogoType]"], input[name="properties[HoodieChestLogoType]"]', function() {
    console.log('👕 [HOODIE SPECIFIC] Roster trigger for:', $(this).attr('name'), 'Type:', $(this).attr('data-name'));
    if (typeof appendNameNumbers === 'function') {
      setTimeout(appendNameNumbers, 50);
      setTimeout(appendNameNumbers, 150);
      setTimeout(appendNameNumbers, 300); // Multiple attempts to ensure it catches
    }
  });

  $(document).on('change', 'input[name="properties[topSmallNumber]"], input[name="properties[TopLastName]"]', function() {
    console.log('👕 [TOP SPECIFIC] Roster trigger for:', $(this).attr('name'), 'Type:', $(this).attr('data-name'));
    if (typeof appendNames === 'function') {
      setTimeout(appendNames, 50);
      setTimeout(appendNames, 150);
    }
  });

  $(document).on('change', 'input[name="properties[pantSmallNumber]"]', function() {
    console.log('👖 [PANT SPECIFIC] Roster trigger for:', $(this).attr('name'));
    if (typeof appendNames === 'function') setTimeout(appendNames, 50);
  });
  
  // Listener for jersey customizations
  $(document).on('change', 'input[name*="showCrest"], input[name*="showChest"], input[name*="frontNumber"], input[name*="backNumber"], input[name*="lastName"]', function() {
    console.log('👕 [JERSEY] Changed:', $(this).attr('name'), '=', $(this).val());
    setTimeout(updateCalculationDisplay, 100);
  });
  
  // Manual trigger function for debugging
  window.manualCalcUpdate = function() {
    console.log('🔧 [MANUAL] Manually triggering calculation update');
    updateCalculationDisplay();
  };
  
  // Initial calculation on page load and set up system
  setTimeout(function() {
    updateCalculationDisplay();
    updateAllDynamicPricing(); // Initialize dynamic pricing
  }, 1000);
  
  console.log('✅ [CALCULATION DISPLAY] Real-time calculation system initialized');
  console.log('✅ [DYNAMIC PRICING] Dynamic pricing system initialized');
  console.log('✅ [LAYOUT] Layout system disabled to prevent design issues');
});